/*global chrome*/

import React, { useState, useEffect, useMemo } from 'react';
// import PropTypes from "prop-types";
import { useNavigate, useLocation } from 'react-router-dom';
import ConfettiExplosion from 'react-confetti-explosion';
import axios from 'axios';

//TODO: probably have to reset or renew user sessions based on activity
import { getUser, getToken, isUserLoggedIn, resetUserSession } from './service/AuthService';
import { setUserGoal } from './service/GoalService';
// import ProblematicLogEntry from './ProblematicLogEntry';
import AudioRecorder from './AudioRecorder'
import GuidedRelapse from './GuidedRelapse'
// import Stopwatch from "./Stopwatch";
import Iframe from './Iframe'
import IframeWeb from './IframeWeb'
import BrowserNotifications from "./BrowserNotifications";
import TextExpander from './TextExpander';
import { RelapseImprovementTextField, ContentRelevanceSlider, LearningContentRequest, LearingContentTakeawaysField, DailyVizReflectionField, DailyVizSlider, DailyRecentTechUseSlider, DailyCurrentConfidenceSlider, DailyGoalDueDate, RelapseImpactDescription, RelapseImpactSlider, ProblematicEndPicker, ProblematicStartPicker, RelapseDescriptionTextField, RelapseReasoningTextField, GoalReasoningTextField, ProgressTakeawaysTextField, DailyGoalTextField, DailyPromptTextField, MaterialSelectBehaviors, MaterialSelectDevices } from './MaterialComponents';

//Goal Completion Inputs
import { GoalCompletionTime, GoalReflectionTextField, GoalCompletedTextField } from './MaterialComponents';

import './css/Checkbox.css';
import './css/Daily.css';
import './css/Timeline.css';
import './css/PopupForm.css';
import './css/Success.css';
import './css/Learning.css';

// import closeBttn from './assets/closeBttn.png';
import relapseAudio from './assets/meditation_set_back.mp3';
import editBttn from './assets/editBttn.svg';
import nextBttn from './assets/nextBttn.svg';
import progressFire from './assets/fire.svg';
import boxedBreathing from './assets/cropped_box_breathing.gif';
import dailyHeroBgAncata from './assets/backgrounds/pexels-ancatakespics-7839420.jpg';
import dailyHeroBgTima from './assets/backgrounds/pexels-tima-miroshnichenko-6389855.jpg';
import dailyHeroBgBetexion from './assets/backgrounds/pexels-betexion-megapixel-click-26649791-6899026.jpg';




//TODO: move this to an environment variable

const dailyContentUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/dailyfetch';
const dailySubmitUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/dailysubmit';
const gymSubmitUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/gymsubmit';
const logFetchUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/problematiclogfetch';
const logSubmitUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/problematiclogsubmit';
const updateGoalUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/goalupdate';
const userGeneratedUploadUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/userupload';

// Pick the daily hero card background here:
// 'ancatakespics' | 'tima' | 'betexion'
const DAILY_HERO_BG_KEY = 'betexion';
const DAILY_HERO_BG_OPTIONS = {
    ancatakespics: dailyHeroBgAncata,
    tima: dailyHeroBgTima,
    betexion: dailyHeroBgBetexion,
};
const dailyHeroBackground = DAILY_HERO_BG_OPTIONS[DAILY_HERO_BG_KEY] || dailyHeroBgAncata;

// Pick action card backgrounds here:
// 'ancatakespics' | 'tima' | 'betexion'
const DAILY_SETBACK_BG_KEY = 'tima';
const DAILY_GYM_BG_KEY = 'ancatakespics';

function buildCardBackgroundStyle(bgKey, overlayAlpha = 0.58) {
    const bg = DAILY_HERO_BG_OPTIONS[bgKey] || dailyHeroBgAncata;
    return {
        backgroundImage: `linear-gradient(160deg, rgba(8, 16, 28, ${overlayAlpha}), rgba(8, 16, 28, 0.35)), url(${bg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
    };
}


//utilty functions -- push to somewhere else

function time(fn, name) {
  const t1 = Date.now();
  fn();
  const t2 = Date.now();
//   //console.log(`${name} took ${(t2 - t1)} ms`);  
}

const FR_WEEKDAY_SHORT = ['sun.', 'mon.', 'tue.', 'wed.', 'thu.', 'fri.', 'sat.'];

function startOfLocaleWeekMonday(d) {
    const dt = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    const day = dt.getDay();
    const diff = day === 0 ? -6 : 1 - day;
    dt.setDate(dt.getDate() + diff);
    return dt;
}

function formatWeekBarLabel(weekMonday, isCurrentWeek) {
    // if (isCurrentWeek) return 'This week';
    // if (isCurrentWeek) return 'This week';
    return weekMonday.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

/** Native tooltip text for a bar (week-aware). */
function weekMinutesTooltip(entry) {
    const m = entry.minutes || 0;
    const unit = m === 1 ? 'min' : 'mins';
    if (entry.isCurrentWeek) return `${m} ${unit} this week`;
    return `${m} ${unit} week of ${entry.label}`;
}

/** Must match y-axis track height so bars sit on the 0 tick. */
const WEEKLY_CHART_PLOT_PX = 140;

/** Rounds up to a readable axis cap so small weekly totals still fill the chart. */
function nextNiceMaxWeeklyAxisMinutes(peakMinutes) {
    const peak = Math.max(0, Number(peakMinutes) || 0);
    if (peak <= 0) return 60;
    const padded = Math.max(peak * 1.22, 12);
    const breaks = [
        15, 20, 30, 45, 60, 90, 120, 150, 180, 240, 300, 360, 420, 480, 540, 600, 720, 900, 1080, 1200, 1440, 1800,
        2100, 2400,
    ];
    const hit = breaks.find((b) => b >= padded);
    if (hit) return hit;
    return Math.max(60, Math.ceil(padded / 60) * 60);
}

function weeklyChartYTicks(maxAxisMinutes) {
    const m = Math.max(1, Number(maxAxisMinutes) || 1);
    const raw = [3, 2, 1, 0].map((i) => Math.round((m * i) / 3));
    const out = [];
    for (const t of raw) {
        if (!out.length || out[out.length - 1] !== t) out.push(t);
    }
    return out;
}

/** Compact y-axis labels: minutes when the scale is sub-hour, otherwise hours. */
function formatWeeklyAxisTickLabel(minutes, maxAxisMinutes) {
    const v = Math.max(0, Number(minutes) || 0);
    if (v === 0) return '0';
    const maxA = Math.max(Number(maxAxisMinutes) || 0, 1);
    if (maxA < 75) return `${v}m`;
    if (v < 60) return `${v}m`;
    const h = v / 60;
    if (Math.abs(h - Math.round(h)) < 0.001) return `${Math.round(h)} h`;
    const t = Math.round(h * 10) / 10;
    return `${t} h`;
}

const WEEKLY_CHART_GHOST_BAR_PX = 16;

/** Bar columns shown when there are fewer than this many real weeks (pad with decorative ghosts on the right). */
const WEEKLY_CHART_VISIBLE_SLOTS = 7;

/** Decorative ghost heights (px) for padded slots — not tied to minutes. */
const WEEKLY_CHART_DECOR_GHOST_HEIGHTS = [100, 150, 90, 120, 170, 130, 90, 170];

/**
 * Chart display order: newest week on the left, older weeks to the right (new weeks "prepend" visually).
 * When there is only one (or few) weeks, pad with placeholder ghosts on the right so the real bar sits at the far left.
 */
function buildWeeklyChartDisplayRows(chronologicalRows) {
    const rows = Array.isArray(chronologicalRows) ? chronologicalRows.filter(Boolean) : [];
    if (rows.length === 0) return [];
    const reversed = [...rows].reverse();
    const padCount = Math.max(0, WEEKLY_CHART_VISIBLE_SLOTS - reversed.length);
    const placeholders = [];
    for (let i = 0; i < padCount; i++) {
        placeholders.push({
            label: '',
            minutes: 0,
            isCurrentWeek: false,
            complete: false,
            isGhostPlaceholder: true,
            ghostHeightPx: WEEKLY_CHART_DECOR_GHOST_HEIGHTS[i % WEEKLY_CHART_DECOR_GHOST_HEIGHTS.length],
        });
    }
    return reversed.concat(placeholders);
}

function deriveWeeklyChartMotivationLine(rows) {
    if (!Array.isArray(rows) || rows.length === 0) return '';
    const n = rows.length;
    if (n === 1) return 'Every journey starts with a single step.';
    if (n === 2) return '2 weeks in. The habit is forming.';
    if (n <= 5) return 'The work is showing up.';
    if (n <= 7) return 'Consistency is a skill.';
    const mins = (e) => Math.max(0, Number(e.minutes) || 0);
    const peak = Math.round(rows.reduce((m, e) => Math.max(m, mins(e)), 0));
    const current = Math.round(mins(rows[rows.length - 1]));
    const declining = peak > 0 && current < peak * 0.75;
    if (declining) {
        return `From ${peak} ${peak === 1 ? 'min' : 'mins'} to ${current} ${current === 1 ? 'min' : 'mins'}. That's the work.`;
    }
    return '8 weeks of showing up. Keep going.';
}

function normalizeWorkoutLog(entry) {
    if (!entry || typeof entry !== 'object') return null;
    const completedAtRaw = entry.completedAt ?? entry.completed_at ?? entry.timestamp ?? entry.createdAt ?? entry.created_at;
    const completedDate = new Date(completedAtRaw);
    if (Number.isNaN(completedDate.getTime())) return null;
    const rawMinutes =
        entry.durationMinutes ??
        entry.duration_minutes ??
        entry.sessionDurationMinutes ??
        entry.session_duration_minutes ??
        entry.sessionDurationMs / 60000 ??
        entry.session_duration / 60000 ??
        entry.sessionDuration / 60000 ??
        entry.repDurationSeconds / 60;
    return {
        username: String(entry.username ?? entry.userId ?? entry.user_id ?? ''),
        workoutType: String(entry.workoutType ?? entry.workout_type ?? entry.exercise_type ?? 'workout'),
        durationMinutes: Math.max(0, Number(rawMinutes) || 0),
        completedAt: completedDate.toISOString(),
    };
}

function buildWeeklyWorkoutChartData(rawLogs) {
    if (!Array.isArray(rawLogs) || rawLogs.length === 0) return [];
    const logs = rawLogs.map(normalizeWorkoutLog).filter(Boolean).sort((a, b) => {
        return new Date(a.completedAt).getTime() - new Date(b.completedAt).getTime();
    });
    if (!logs.length) return [];

    const weeklyMap = new Map();
    const firstWeekStart = startOfLocaleWeekMonday(new Date(logs[0].completedAt));
    const nowWeekStart = startOfLocaleWeekMonday(new Date());

    logs.forEach((log) => {
        const weekStart = startOfLocaleWeekMonday(new Date(log.completedAt));
        const key = weekStart.toISOString();
        if (!weeklyMap.has(key)) {
            weeklyMap.set(key, { weekStart, minutes: 0, complete: false });
        }
        const row = weeklyMap.get(key);
        row.minutes += Math.max(0, Number(log.durationMinutes) || 0);
        row.complete = true;
    });

    const result = [];
    const cursor = new Date(firstWeekStart);
    while (cursor <= nowWeekStart) {
        const key = cursor.toISOString();
        const row = weeklyMap.get(key);
        const isCurrentWeek = key === nowWeekStart.toISOString();
        result.push({
            label: formatWeekBarLabel(cursor, isCurrentWeek),
            minutes: Math.round(((row && row.minutes) || 0) * 10) / 10,
            isCurrentWeek,
            complete: !!(row && row.complete),
        });
        cursor.setDate(cursor.getDate() + 7);
    }

    return result.slice(-12);
}

/** Parse API row to Monday of that week (label like "Apr 20" or explicit weekStart). */
function weekMondayFromChartRow(row, refYear) {
    if (!row || typeof row !== 'object') return null;
    if (row.weekStart != null) {
        const d = new Date(row.weekStart);
        return Number.isNaN(d.getTime()) ? null : startOfLocaleWeekMonday(d);
    }
    if (row.week_start != null) {
        const d = new Date(row.week_start);
        return Number.isNaN(d.getTime()) ? null : startOfLocaleWeekMonday(d);
    }
    if (typeof row.label === 'string' && row.label.trim()) {
        const label = row.label.trim();
        for (const y of [refYear, refYear - 1]) {
            const d = new Date(`${label}, ${y}`);
            if (!Number.isNaN(d.getTime())) return startOfLocaleWeekMonday(d);
        }
    }
    return null;
}

/**
 * Backend weeklyProgress is often sparse (only weeks with workouts). Fill every Monday
 * from the earliest known week through the current week so ghost bars render for gaps.
 */
function expandWeeklyChartRowsSparse(apiRows) {
    if (!Array.isArray(apiRows) || apiRows.length === 0) return [];
    const refYear = new Date().getFullYear();
    let earliest = null;
    const byKey = new Map();

    apiRows.forEach((row) => {
        const wm = weekMondayFromChartRow(row, refYear);
        if (!wm) return;
        const key = wm.toISOString();
        if (!earliest || wm.getTime() < earliest.getTime()) earliest = new Date(wm);
        const mins = Math.max(0, Number(row.minutes ?? row.duration_minutes ?? row.durationMinutes) || 0);
        const prev = byKey.get(key);
        if (!prev || mins > (Number(prev.minutes) || 0)) {
            byKey.set(key, { ...row, minutes: mins });
        }
    });

    if (!earliest) return apiRows;

    const nowWeek = startOfLocaleWeekMonday(new Date());
    const result = [];
    const cursor = new Date(earliest);
    while (cursor.getTime() <= nowWeek.getTime()) {
        const key = startOfLocaleWeekMonday(new Date(cursor)).toISOString();
        const isCurrentWeek = key === nowWeek.toISOString();
        const hit = byKey.get(key);
        if (hit) {
            const m = Math.max(0, Number(hit.minutes) || 0);
            result.push({
                label: typeof hit.label === 'string' && hit.label ? hit.label : formatWeekBarLabel(cursor, isCurrentWeek),
                minutes: Math.round(m * 10) / 10,
                isCurrentWeek,
                complete: m > 0 ? hit.complete !== false : false,
            });
        } else {
            result.push({
                label: formatWeekBarLabel(cursor, isCurrentWeek),
                minutes: 0,
                isCurrentWeek,
                complete: false,
            });
        }
        cursor.setDate(cursor.getDate() + 7);
    }
    return result.slice(-12);
}

function resolveWeeklyBarChartData(weeklyProgress, workoutLogs) {
    const logs = Array.isArray(workoutLogs) ? workoutLogs : [];
    const denseFromLogs = buildWeeklyWorkoutChartData(logs);
    if (denseFromLogs.length > 0) return denseFromLogs;
    return expandWeeklyChartRowsSparse(Array.isArray(weeklyProgress) ? weeklyProgress : []);
}

function StreakCelebrateBlock({ streak, days, onContinue }) {
    const n = Number(streak) || 0;
    return (
        <div className="streakCelebrateShell">
            <div className="streakCelebrateHero">
                <div className="streakFlameGraphic" aria-hidden>🔥</div>
                <div className="streakCelebrateNumber">{n}</div>
                <div className="streakCelebrateTagline">day streak!</div>
            </div>
            <div className="streakWeekCard">
                <div className="streakWeekRow">
                    {days.map((day, i) => (
                        <div key={i} className="streakDayCell">
                            <div
                                className={
                                    'streakDayMark' +
                                    (day.complete ? ' isComplete' : '') +
                                    (day.isToday ? ' isToday' : '')
                                }
                            >
                                {day.complete ? <span className="streakDayCheck">✓</span> : null}
                            </div>
                            <div className={'streakDayLabelFr' + (day.isToday ? ' isToday' : '')}>{day.labelFr}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

const DailyContent = () => {
    const user = getUser();
    const token = getToken();
    console.log('user test: ', user);
    const name = user !== 'undefined' && user ? (user.name || user.fieldName) : user.fieldName;
    const username = user !== 'undefined' && user ? user.username: '';


    // setUserGoal({ "textcontent": dailyGoalTitle, "notifications": dailyGoalNotification})

    const dateObj = new Date()
    const tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
    const localISOTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1);
    const date = localISOTime

    const [errorMessage, setErrorMessage] = useState('');
    const [isLoading, setLoading] = useState(true);
    const [dailyContent, setDailyContent] = useState('');
    const [learningContent, setLearningContent] = useState('');
    const [contentFeedback, setContentFeedback] = useState('');
    const [dailyLearning, setDailyLearning] = useState('');
    const [learningFeedback, setLearningFeedback] = useState("Medium");
    const [dailyPrompt, setDailyPrompt] = useState('');
    const [dailyPromptText, setDailyPromptText] = useState('');
    const [promptFeedback, setPromptFeedback] = useState("Medium");
    const [dailyGoal, setDailyGoal] = useState('');
    const [goalFeedback, setGoalFeedback] = useState("Medium");
    const [goalCompleted, setGoalCompleted] = useState(false);
    const [workoutCompleted, setWorkoutCompleted] = useState(false);
    const [fieldName, setFieldName] = useState('');


    const [contentRelevance, setContentRelevance] = useState(false);
    const [contentRequest, setContentRequest] = useState('');
    const [learningContentTakeaways, setLearningContentTakeaways] = useState(false);



    const [dailyGoalTitle, setDailyGoalTitle] = useState('');
    const [dailyGoalDate, setDailyGoalDate] = useState('');
    const [dailyGoalReason, setDailyGoalReason] = useState('');
    const [dailyGoalNotification, setDailyGoalNotifications] = useState('');
    const [currentGoal, setCurrentGoal] = useState('');
    const [goalCount, setGoalCount] = useState(0);
    const [workoutStreak, setWorkoutStreak] = useState(0);
    const [weeklyBarChartData, setWeeklyBarChartData] = useState([]);
    const [weeklyChartLoading, setWeeklyChartLoading] = useState(true);

    const [weekChartSelectedIndex, setWeekChartSelectedIndex] = useState(null);

    const weeklyChartDisplayRows = useMemo(
        () => buildWeeklyChartDisplayRows(weeklyBarChartData),
        [weeklyBarChartData]
    );

    useEffect(() => {
        const len = weeklyChartDisplayRows.length;
        setWeekChartSelectedIndex((prev) => {
            if (len === 0) return null;
            if (prev == null || prev < 0 || prev >= len) return 0;
            const picked = weeklyChartDisplayRows[prev];
            if (picked && picked.isGhostPlaceholder) return 0;
            return prev;
        });
    }, [weeklyChartDisplayRows]);

    const weekChartSafeIndex = useMemo(() => {
        const n = weeklyChartDisplayRows.length;
        if (weekChartSelectedIndex != null && weekChartSelectedIndex >= 0 && weekChartSelectedIndex < n) {
            const picked = weeklyChartDisplayRows[weekChartSelectedIndex];
            if (picked && !picked.isGhostPlaceholder) return weekChartSelectedIndex;
        }
        const firstReal = weeklyChartDisplayRows.findIndex((r) => r && !r.isGhostPlaceholder);
        return firstReal >= 0 ? firstReal : 0;
    }, [weeklyChartDisplayRows, weekChartSelectedIndex]);

    const weeklyChartAxis = useMemo(() => {
        const rows = Array.isArray(weeklyBarChartData) ? weeklyBarChartData : [];
        const peak = rows.reduce((acc, e) => Math.max(acc, Number(e.minutes) || 0), 0);
        const maxAxisMinutes = nextNiceMaxWeeklyAxisMinutes(peak);
        return { maxAxisMinutes, yTicks: weeklyChartYTicks(maxAxisMinutes) };
    }, [weeklyBarChartData]);

    const weeklyChartMotivationLine = useMemo(() => deriveWeeklyChartMotivationLine(weeklyBarChartData), [weeklyBarChartData]);

    //Popup Goal Submit UI
    const [goalSubmitUI, setGoalSubmitUI] = useState('');
    const [goalPostSubmitUI, setGoalPostSubmitUI] = useState('');

    //Popup Goal Submit Input
    const [goalCompletedInput, setGoalCompletedInput] = useState('');
    function handleGoalCompletedInput(newValue) {
        console.log(newValue)
        setGoalCompletedInput(newValue);
    }
    const [goalCompletionDateInput, setGoalCompletionDateInput] = useState('');
    function handleGoalCompletionDateInput(newValue) {
        console.log(newValue)
        setGoalCompletionDateInput(newValue);
    }
    const [goalCompletedReflectionInput, setGoalCompletedReflectionInput] = useState('');
    function handleGoalCompletedReflectionInput(newValue) {
        console.log(newValue)
        setGoalCompletedReflectionInput(newValue);
    }
    

    //Audio Journal UI
     const [showTextJournal, setShowTextJournal] = useState(false); // Toggle text journaling
    const [textJournal, setTextJournal] = useState(""); // Journal entry state
    const handleTextChange = (event) => {
        setTextJournal(event.target.value);
    };

    //Relapse Prevention Plan
    const [relapsePlanText, setRelapsePlanText] = useState('');


    //Relapse Form
    const [problematicUseStart, setProblematicUseStart] = useState('');
    function handleProblematicUseStart(newValue) {
        setProblematicUseStart(newValue);
    }
    const [problematicUseEnd, setProblematicUseEnd] = useState('');
    function handleProblematicUseEnd(newValue) {
        setProblematicUseEnd(newValue);
    }
    const [relapseBehaviors, setRelapseBehaviors] = useState('');
    function handleRelapseBehaviors(newValue) {
        setRelapseBehaviors(newValue);
    }
    const [relapseDevices, setRelapseDevices] = useState('');
    function handleRelapseDevices(newValue) {
        setRelapseDevices(newValue);
    }
    const [relapseDescription, setRelapseDescrption] = useState('');
    function handleRelapseDescription(newValue) {
        setRelapseDescrption(newValue);
    }
    const [relapseReasoning, setRelapseReasoning] = useState('');
    function handleRelapseReasoning(newValue) {
        setRelapseReasoning(newValue);
    }

    const [relapseImprovementText, setRelapseImprovementText] = useState('');
    function handleRelapseImprovementText(newValue) {
        setRelapseImprovementText(newValue);
    }

    const [relapseImpactValue, setRelapseImpactValue] = useState('');
    function handleRelapseImpactValue(newValue) {
        setRelapseImpactValue(newValue);
    }
    const [relapseImpactDescriptionValue, setRelapseImpactDescriptionValue] = useState('');
    function handleRelapseImpactDescriptionValue(newValue) {
        setRelapseImpactDescriptionValue(newValue);
    }


    //Progress Data
    const [pastGoalStatus, setPastGoalStatus] = useState('');
    const [recentTechUse, setRecentTechUse] = useState('');
    const [progressConfidence, setprogressConfidence] = useState('');

    const [morningUse, setMorningUse] = useState('');
    const [afternoonUse, setAfternoonUse] = useState('');
    const [nightUse, setNightUse] = useState('');
    const [currentConfidence, setCurrentConfidence] = useState('');
    const [yesterdayTakeaways, setYesterdayTakeaways] = useState('');


    //Learning Form
    const [dailyJournalBody, setDailyJournalBody] = useState('');
    const [dailyGoalBody, setDailyGoalBody] = useState('');
    const [dailyProgressBody, setDailyProgressBody] = useState('');
    const [dailyVisualization, setDailyVisualization] = useState('');
    const [learningSuccess, setLearningSuccess] = useState('');
    const [learningProgress, setLearningProgress] = useState('');

    //Confetti!
    const [isExploding, setIsExploding] = useState(false);
    const largeProps = {
        force: 0.9,
        duration: 4000,
        particleCount: 400,
        width: 2000,
        zIndex: 300,
        colors: ['#041E43', '#1471BF', '#5BB4DC', '#FC027B', '#66D805'],
    };

    //Learning Form Data (move it here)
    function handleAudioState(newValue) {
        setAudio(newValue);
    }
    function handleDailyGoalTitle(newValue) {
        setDailyGoalTitle(newValue);
        // setUserGoal({ "textcontent": dailyGoalTitle, "notifications": dailyGoalNotification})
    }
    function handleDailyJournalPrompt(newValue) {
        // let newDailyPrompt = dailyPrompt
        // newDailyPrompt.previousPrompt = newDailyPrompt.textcontent
        // newDailyPrompt.textcontent = newValue
        // newDailyPrompt.status = 'updated'
        // setDailyPrompt(newDailyPrompt);
        setDailyPromptText(newValue);
        // setUserGoal({ "textcontent": dailyGoalTitle, "notifications": dailyGoalNotification})
    }
    function handleDailyGoalDue(newValue) {
        setDailyGoalDate(newValue);
    }
    function handleDailyReason(newValue) {
        setDailyGoalReason(newValue);
    }
    function handleContentRelevance(newValue){
        setContentRelevance(newValue)
    }
    function handleContentRequest(newValue){
        setContentRequest(newValue)
    }
    function handleLearingContentTakeaways(newValue){
        setLearningContentTakeaways(newValue)
    }
    function handleRecentTechUse(newValue){
        setRecentTechUse(newValue)
    }
    function handleProgressConfidence(newValue){
       setprogressConfidence(newValue)

    }
    function handleProgressTakeaways(newValue){
        setYesterdayTakeaways(newValue)
    }

    async function updateGoalStatus(goalState, localgoalCompletedInput, localgoalCompletionDateInput, localgoalCompletedReflectionInput){
        //TODO: move this to an environment variable
        // await time(setGoalSubmissionPopup, 'setGoalSubmissionPopup');
        // alert('here')
        
        const requestConfig = {
            headers: {
                'x-api-key': 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB'
            }
        }

        const requestBody = {
            username: username,
            token: token,
            date: date,
            goalState: goalState,
            goalCompletedInput: localgoalCompletedInput,
            goalCompletionDateInput: localgoalCompletionDateInput,
            goalCompletedReflectionInput: localgoalCompletedReflectionInput
        }
        // console.log('goalstate:', goalState)
        // console.log('goalCompletedInput:', localgoalCompletedInput)
        // console.log('goalCompletionDateInput:', localgoalCompletionDateInput)
        // console.log('goalCompletedReflectionInput:', localgoalCompletedReflectionInput)
        // console.log(requestBody)

        axios.post(updateGoalUrl, requestBody, requestConfig).then(response => {
            // //console.log('goal status updated')            
            
        }).catch(error => {
            //console.log('error')
            //console.log(error)
            //TODO: fix error of receiving null error
            if(error.response.status === 401 || error.response.status === 403 ){
                setErrorMessage(error.response.data.message);
            }
            else{
                setErrorMessage('Sorry the server is down. Please try again later.');

            }
        })
    };

    function handleGoalCompleted(){
        // //console.log('goal status: ', !goalCompleted)
        handleOpenGoalSubmitPopup()
        // setGoalCompleted(!goalCompleted)
        // updateGoalStatus(!goalCompleted)


        //make call to update state of goal
    }

    //Popup
    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [answers, setAnswers] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [showLearningPopup, setShowLearningPopup] = useState(false);
    const [showRelapsePopup, setShowRelapsePopup] = useState(false);
    
    const [journalAudio, setAudio] = useState(null);

    const navigate = useNavigate()
    const location = useLocation();
    //Relapse Log
    const [relapsePlan, setRelapsePlan] = useState('');
    const [relapseIntro, setRelapseIntro] = useState('');
    const [relapseTime, setRelapseTime] = useState('');
    const [relapseBackground, setRelapseBackground] = useState('');
    const [relapseInformation, setRelapseInformation] = useState('');
    const [relapseWhy, setRelapseWhy] = useState('');
    const [relapseImpact, setRelapseImpact] = useState('');
    const [relapseImprovement, setRelapseImprovement] = useState('');
    const [relapseSuccess, setRelapseSuccess] = useState('');

    //Regulation Log
    const [regulationIntro, setRegulationIntro] = useState('');
    const [regulationExercise, setRegulationExercise] = useState('');
    const [motivationPrompts, setMotivationPrompts] = useState('');

    //Relapse Entries
    const timeElapsedRelapse = Date.now();
    const todayRelapse = new Date(timeElapsedRelapse);
    const entries = []
    const [entryHTML, setEntryHTML] = useState(null);
    const [lastSubmitDate, setLastSubmitDate] = useState(todayRelapse);
    const [lastTitle, setLastTitle] = useState('');
    const [lastDescription, setLastDescription] = useState('');
    const [lastLesson, setLastLesson] = useState('');
    const [lastImpact, setLastImpact] = useState('');

    //Spinner
    const loadingSpinner = document.querySelector('.donut');


    // async function fetchRelapseLog(){
    //      // do stuff here...
    //     // //console.log('here again')
    //     //TODO: move this to an environment variable
    //     const requestConfig = {
    //         headers: {
    //             'x-api-key': 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB'
    //         }
    //     }

    //     const moduleParams = {
    //         mode: 'default'
    //     };

    //     const requestBody = {
    //         username: user.username,
    //         token: token,
    //         module: moduleParams,
    //     }
        
    //     axios.post(logFetchUrl, requestBody, requestConfig).then(response => {
    //         //console.log('relapse log response object: ', response)
    //         //TODO: through here fetch the daily goal and the big long term goal as well
    //         // //console.log('returned body')
    //         // //console.log(`Status: ${response.status}`);
    //         // //console.log('Body: ', response.data);
    //         // //console.log('response')
    //         // //console.log(response.data.dynamoContent[response.data.dynamoContent.length-1])
    //         setLastImpact(response.data.dynamoContent[response.data.dynamoContent.length-1].relapseImpactDescriptionValue)
    //         setLastLesson(response.data.dynamoContent[response.data.dynamoContent.length-1].relapseImprovementText)
    //         setLastTitle(convertTimestampToDateString(Number(response.data.dynamoContent[response.data.dynamoContent.length-1].problematicUseStart)))
    //         setLastDescription(response.data.dynamoContent[response.data.dynamoContent.length-1].relapseDescription)  
    //         // //console.log('last submit date yooo: ', new Date(Number(response.data.dynamoContent[response.data.dynamoContent.length-1].sk)))          
    //         if(response.data.dynamoContent.length>=1){
    //             setLastSubmitDate(new Date(Number(response.data.dynamoContent[response.data.dynamoContent.length-1].sk)))
    //         }
    //         for (let index = 0; index < response.data.dynamoContent.length; index++) {
    //             const entry = response.data.dynamoContent[index];
    //             entries.push(<hr></hr>)
    //             entries.push(<ProblematicLogEntry lastSubmitDate = {new Date(Number(entry.sk)).toString()} lastImpact= {entry.relapseImpactDescriptionValue} lastLesson= {entry.relapseImprovementText} entryDescription= {entry.relapseDescription} entryTitle= {convertTimestampToDateString(Number(entry.problematicUseStart))} />)
    //         }
    //         setEntryHTML(entries)
    //         //console.log(entries)
    //     }).catch(error => {
    //         //TODO: fix error of receiving null error
    //         //console.log('returned error')
    //         console.error(error);
    //         setErrorMessage('Sorry the server is down. Please try again later.');
    //         if(error.response.status === 401 || error.response.status === 403 ){
    //             setErrorMessage(error.response.data.message);
    //         }
    //         else{
    //             setErrorMessage('Sorry the server is down. Please try again later.');

    //         }
    //     })
    // }
 

    async function setGoalSubmissionPopup(){
        const now = new Date();
        const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const currentStreak = workoutStreak;
        const streakDays = Math.max(0, Number(workoutStreak) || 0);
        const last7Days = [];
        for (let daysAgo = 6; daysAgo >= 0; daysAgo--) {
            const d = new Date(todayStart);
            d.setDate(todayStart.getDate() - daysAgo);
            const isToday = daysAgo === 0;
            const complete = streakDays > 0 && daysAgo < streakDays;
            last7Days.push({
                complete,
                isToday,
                labelFr: FR_WEEKDAY_SHORT[d.getDay()],
            });
        }

        setGoalSubmitUI(
            <div className="learningFeedback">
                <div className="container dailyGoal" style={{ flexDirection: 'column' }}>
                    <div>
                        <GoalCompletedTextField id="goalCompletedInput" placeholder="Describe goal completed and the steps you took to achieve it" rows="2" handleChange={handleGoalCompletedInput}/>
                        <div className="relapseQuestion">What did you do?</div>
                    </div>
                    <div>
                        <GoalReflectionTextField id="goalReflectionInput" placeholder="Share how completing the goal made you feel or what you learned" rows="2" handleChange={handleGoalCompletedReflectionInput}/>
                        <div className="relapseQuestion">Reflect on the why. How do you feel?</div>
                    </div>
                    <div>
                        <GoalCompletionTime id="goalCompletionDateInput" placeholder="Goal completion time" handleChange={handleGoalCompletionDateInput}/>
                        <div className="relapseQuestion">When did you complete the goal?</div>
                    </div>
                    <div className="formBttnContainer" style={{ bottom: '1rem' }}>
                        <button className="popupButton" style={{ marginTop: '1rem'}} onClick={completeGoal} > Complete Goal </button>
                    </div>
                </div>
            </div>
        )
        setGoalPostSubmitUI(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo"> Keep showing up for yourself! Lasting change is built one step at a time. </p>
                </div>
                <div>
                    <div className="dummy-positioning d-flex">  
                        <div className="success-icon">
                            <div className="success-icon__tip"></div>
                            <div className="success-icon__long"></div>
                        </div>
                    </div>
                </div>
                {/* <div className='learningProgressBody' style={{display:'none'}}>
                    <div className='learningProgressContainer'>
                        <img className="learningProgressIcon" src={progressFire} alt="Logo" />
                        <img className="learningProgressIcon incompleteIcon" src={progressFire} alt="Logo" />
                        <img className="learningProgressIcon incompleteIcon" src={progressFire} alt="Logo" />
                        <img className="learningProgressIcon incompleteIcon" src={progressFire} alt="Logo" />
                        <img className="learningProgressIcon incompleteIcon" src={progressFire} alt="Logo" />
                    </div>
                    <div>Goal: Use Trampoline 5 times this week</div>
                </div> */}
                <div id="learning-progress-success-body" className='learningProgressBody' style={{display:'none', marginTop:'0'}}>
                    <StreakCelebrateBlock
                        streak={currentStreak}
                        days={last7Days}
                        onContinue={handleCloseGoalSubmitPopup}
                    />
                </div>
                {/* <div>
                    {isExploding && <ConfettiExplosion {...largeProps} />}
                </div> */}
                {/* <button className="button" onClick={() => setIsExploding(!isExploding)}>
                    {isExploding && <ConfettiExplosion {...largeProps}/>}
                    <span>small</span>
                </button> */}
                <div className="formBttnContainer" style={{ bottom: '1rem' }}>
                    <button className="popupButton" onClick={() => {window.open("https://trampolinehealth.circle.so/join?invitation_token=3cff0ae5ec294f740a32bac3219619a5e2e27ed9-a1faea1f-4698-44e9-be22-47c01f9a128d", "_blank");}} >Share with Community</button>
                    <button className="popupButton" style={{ marginTop: '1rem'}} onClick={handleCloseGoalSubmitPopup} > Done </button>
                </div>
            </div> 
        )
    }

    async function setRegulationLog(){
        setRegulationIntro(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo"> Urges rise and fall like waves. Pause and anchor yourself in the present moment. Breathe deeply. Watch the emotions wash over you without judgement. Reflect on how far you've come. This too shall pass. </p>
                </div>
                <div className="formBttnContainer" style={{bottom:'3rem'}}>
                    <button className="popupButton" onClick={handleRegulationMotivation} > Quick Refocus</button>
                    <button className="popupButton" onClick={handleNextQuestion}  style={{ marginTop: '1rem' }} >Mindfulness</button>
                    {/* <button className="popupButton" style={{ marginTop: '1rem' }} onClick={handleChatNavigate} >Chat Support</button> */}
                    {/* <button className="popupButton" onClick={handleOverehelmedPreventionPlan} style={{ marginTop: '1rem' }} >Prevention Plan</button> */}

                </div>
            </div> 
        )
        setRegulationExercise(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo" style={{marginTop:"0"}}> This body scan exercise is meant to strengthen the mind body connection and help over time strengthen awareness. </p>
                </div>
                <Iframe source='https://www.youtube.com/embed/6iDKF-TrAfE?si=0HVzjZsQmgpjiHT3&amp' start='22' height='50%' />
            </div> 
        )
        setMotivationPrompts(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo" style={{marginTop:"0"}}> Take it one intentional step at a time. Set backs happen, that's ok. Start small. What can you do to get back on track?</p>
                </div>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                }}>
                    <div className="relapseQuestion">Let's breathe and recenter. When you're ready just jump back.</div>
                    <img className="learningProgressIcon" src={boxedBreathing} style={{borderRadius: "10rem", height:'240px', width:'240px', marginTop:'1rem'}} alt="Logo" />
                    <div className="guidedRelapse" style={{
                        position: 'absolute',
                        bottom: '6.5rem',
                        right: '5rem',
                        }}>
                            <div> <GuidedRelapse saveAudio= {handleAudioState} /> </div>                   
                    </div>
                </div>
                <div className="formBttnContainer" style={{bottom:'0rem'}}>
                    {/* <button className="popupButton" onClick={handleOverehelmedPreventionPlan} style={{ marginTop: '1rem' }} >Prevention Plan</button> */}
                </div>
            </div> 
        )
    }


    async function setRelapseLog(){
        setRelapsePlan(
            <div className="learningFeedback">
                <div style={{overflowY: "auto", height: "80%", minHeight:"470px", textAlign: "center" }} dangerouslySetInnerHTML={{__html: relapsePlanText}} >
                </div>
                <div className="formBttnContainer">
                    <button className="popupButton" style={{ marginTop: '1rem' }} onClick={handleCloseRelapsePopup} >Commit To Plan</button>
                </div>
            </div> 
        )
        setRelapseIntro(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo"> Set backs are a part of the process. Focus on the progress you've made. Take a deep breath. Let’s figure out what comes next. </p>
                </div>
                <div className="formBttnContainer">
                    {/* <button className="popupButton" onClick={handleRelapsePreventionPlan} >Prevention Plan</button> */}
                    <button className="popupButton" onClick={handleOpenRegulationPopup} style={{ marginTop: '1rem' }} >Get Back on Track</button>
                    <button className="popupButton" onClick={handleNextQuestion} style={{ marginTop: '1rem' }} >Set Back Journal</button>
                    <button className="popupButton" style={{ marginTop: '1rem' }} onClick={handleGymNavigate} >Wellness Exercises</button>
                </div>
            </div> 
        )
        setRelapseTime(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo"> By tracking your set backs, you can better understand your patterns. </p>
                </div>
                <div>
                    <div className="relapseQuestion">When did the set back start?</div>
                    {/* <input type="text" value={morningUse} placeholder="1-10 (1 as in poor 10 as in great)" onChange={event => setMorningUse(event.target.value)} /> <br /> */}
                    <ProblematicStartPicker handleChange={ handleProblematicUseStart }/>
                </div>
                <div>
                    <div className="relapseQuestion">When did the set back end?</div>
                    {/* <input type="text" value={morningUse} placeholder="1-10 (1 as in poor 10 as in great)" onChange={event => setMorningUse(event.target.value)} /> <br /> */}
                    <ProblematicEndPicker handleChange={ handleProblematicUseEnd }/>
                </div>
            </div> 
        )
        setRelapseBackground(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo"> Don't be discouraged. Logging this helps you learn and get back on track. You've got this! </p>
                </div>
                <div>
                    <div className="relapseQuestion">Which of the following behavior(s) occurred?</div>
                    <MaterialSelectBehaviors handleChange={ handleRelapseBehaviors }/>
                    </div>
                <div>
                    <div className="relapseQuestion"> What device(s) did you use?</div>
                    <MaterialSelectDevices handleChange={ handleRelapseDevices }/>
                </div>
            </div> 
        )
        setRelapseInformation(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo"> The only true failure is giving up. Use this as motivation to keep moving forward.  </p>
                </div>
                <div>
                    <div style={{ marginBottom: '1rem' }} className="relapseQuestion">What happened?</div>
                    <RelapseDescriptionTextField placeholder="Description of what happened" handleChange={ handleRelapseDescription }/>
                </div>
            </div> 
        )
        setRelapseWhy(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo"> The only true failure is giving up. Use this as motivation to keep moving forward.  </p>
                </div>
                <div>
                    <div style={{ marginBottom: '1rem' }} className="relapseQuestion">Why do you think it happened?</div>
                    <RelapseReasoningTextField placeholder="Think about the circumstances and possible triggers" handleChange={ handleRelapseReasoning }/>
                </div>
            </div> 
        )
        setRelapseImpact(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo"> You've come too far to turn back now. Let's overcome this together.  </p>
                </div>
                <div>
                    <div className="relapseQuestion">Rate the impact (1-10)?</div>
                    <RelapseImpactSlider placeholder="Think about the circumstances and possible triggers" handleChange={ handleRelapseImpactValue }/>
                </div>
                <div>
                    <div className="relapseQuestion">Describe the impact?</div>
                    <RelapseImpactDescription rows='3' placeholder="Think about how your set back affected you in the short and long term." handleChange={ handleRelapseImpactDescriptionValue }/>
                </div>
            </div> 
        )
        setRelapseImprovement(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo"> This is a setback that sets you up for future success if you choose to learn from it. </p>
                </div>
                <div>
                    <div style={{ marginBottom: '1rem' }} className="relapseQuestion">What did you learn? What is one thing you will do differently?</div>
                    <RelapseImprovementTextField placeholder="Think about the circumstances and possible triggers" handleChange={ handleRelapseImprovementText }/>
                </div>
            </div> 
        )
        setRelapseSuccess(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo"> Getting back on track starts with self-compassion. Let's grow from this setback. </p>
                </div>
                <div>
                    <p id="relapseImprovementTextBody"> <b>Insight: </b> {relapseImprovementText} </p>
                </div>
                <div className="formBttnContainer" style={{bottom:'3rem'}}>
                    <button className="popupButton" onClick={() => {navigator.clipboard.writeText(relapseImprovementText);}}   style={{ marginTop: '1rem' }} >Copy Text</button>
                    <button className="popupButton" style={{ marginTop: '1rem' }} onClick={() => {window.open("https://trampolinehealth.circle.so/join?invitation_token=3cff0ae5ec294f740a32bac3219619a5e2e27ed9-a1faea1f-4698-44e9-be22-47c01f9a128d", "_blank");}} > Community Support </button>
                    {/* <button className="popupButton" style={{ marginTop: '1rem' }} onClick={handleChatNavigate} >Chat Support</button> */}
                </div>
            </div> 
        )
    }

    async function fetchDailyContent(){
        ////console.log('requestBody!!: ', requestBody)
        ////console.log('requestConfig!!: ', requestConfig)
        // document.querySelector('.header')[0].style.display = 'block'
        setWeeklyChartLoading(true);
        axios.post(dailyContentUrl, requestBody, requestConfig).then(response => {
            console.log('returned body - daily content')
            console.log(`Status: ${response.status}`);
            console.log('Body: ', response.data);
            console.log('maybe?: ', response.data['dynamoContent'])
            console.log('confused: ', response.data.dynamoContent)
            console.log('response')
            console.log('preventionplan text: ', response.data.preventionPlan)

            console.log(response.data.dynamoContent)
            const content = response.data.dynamoContent
            const todayEntry = response.data.dynamoEntry
            const currentUserGoal = response.data.dynamoUserGoal
            const currentGoalCount = response.data.goalCount
            const currentWorkoutStreak = response.data.workoutStreak
            const preventionPlan = response.data.preventionPlan
            const lastSetBack = new Date(response.data.lastSetBack)
            const weeklyProgress = response.data.weeklyProgress;


            console.log("last set back: ", lastSetBack)

            ////console.log('preventionplan text: ', preventionPlan)
            setCurrentGoal(currentUserGoal)
            setGoalCount(currentGoalCount)
            setWorkoutStreak(currentWorkoutStreak)

            const workoutLogs =
                response.data.workoutLogs ??
                response.data.weeklyWorkoutLogs ??
                response.data.gymWorkoutLogs ??
                response.data.workoutData ??
                [];
            setWeeklyBarChartData(resolveWeeklyBarChartData(weeklyProgress, workoutLogs));
            
            
            setDailyContent(content);
            setRelapsePlanText(preventionPlan)
            setLastSubmitDate(lastSetBack)

            setRelapsePlan(
            <div className="learningFeedback" style={{height: "80%"}} >
                <div style={{overflowY: "auto", height: "80%", textAlign: "center" }}>
                    <div dangerouslySetInnerHTML={{__html: response.data.preventionPlan}} ></div>
                </div>
                <div className="formBttnContainer" style={{ bottom: '1rem' }}>
                    <button className="popupButton" style={{ marginTop: '1rem' }} onClick={handleCloseRelapsePopup} >Commit To Plan</button>
                </div>
            </div> 
        )

            //console.log('learning: ', content.learning)
            //console.log('journal: ', content.journal)
            //console.log('goal: ', content.goal)

            console.log('todayEntry: ', todayEntry)

            setDailyLearning(content.learning.content)
            setDailyPrompt(content.journal.content)
            setDailyPromptText(content.journal.content.textcontent)
            setDailyGoal(content.goal.content)
            setDailyGoalTitle(content.goal.content.textcontent)

            //TODO: check to see the logic here. feel like the bug is when i do a workout it the morning it is misassigned

            if (Object.keys(todayEntry).length > 0) {
                // //console.log('object is empty');
                if("goalContent" in todayEntry){
                    setDailyGoalTitle(todayEntry.goalContent.selectedGoal.textcontent)
                }
                else{
                    setDailyGoalTitle("Error fetching goal")
                }
                //set workout to complete
                // document.getElementsByClassName('workoutInput')[0].checked = true
                setWorkoutCompleted(true)
                if("completedGoal" in todayEntry){
                    setGoalCompleted(true)
                }
                let timeline = document.getElementsByClassName('learningTimeline')
                for (let index = 0; index < timeline.length; index++) {
                    timeline[index].style.backgroundColor = 'darkgrey'
                }
                let welcome = document.getElementById('todayWelcome')
                if(welcome){
                    welcome.innerText = 'Hello ' + name + ' here is your daily training session (completed!)'
                }
            }
            // setDailyGoalNotifications(content.goal.notifications)
            //TODO: remove later -- for demonstration purposes
            // setDailyGoalNotifications("alert at 6:00pm")
            if(content.learning.content.type === 'video'){
                // setLearningContent( <div><Iframe source={ content.learning.content.url} start={content.learning.progress} /> <p>Content Feedback</p> <textarea className="textinput" name="paragraph_text" cols="50" value={contentFeedback} onChange={event => setContentFeedback(event.target.value)}></textarea></div>)
                setLearningContent( <div><Iframe source={ content.learning.content.url} start={content.learning.progress} /></div>)

            }
            else if (content.learning.content.type=== 'webpage'){
                setLearningContent( <div><IframeWeb height="350" source={ content.learning.content.url }/></div>)
            }
            else{
                setLearningContent(<div className="learningTextContent" style={{overflowY: "auto", height: "80%", minHeight:"470px", textAlign: "center"}}dangerouslySetInnerHTML={{__html: content.learning.content.textcontent}}></div>)
                // setLearningContent('<p>' + content.learning.content.textcontent +  '</p>' + <textarea className="textinput" name="paragraph_text" cols="50" value={contentFeedback} onChange={event => setContentFeedback(event.target.value)}></textarea>)
            }
            // ContentRelevanceSlider, LearningContentRequest, LearingContentTakeawaysField

            setContentFeedback(
                <div className="learningFeedback">
                    <div className="container" style={{ flexDirection: 'column' }}>
                        {/* <input type="text" value={content.goal.content.textcontent} onChange={event => setDailyGoalTitle(event.target.value)} /> <br /> */}
                        {/* <div>
                            <div className="relapseQuestion">Previous Goal Status</div>
                            <MaterialStatusSelect handleChange={handlePreviousGoalStatus}/>
                        </div> */}
                        <div>
                            <p className="questionInfo">  Rate, 1 (Not Useful) to 10 (Very Useful)</p>
                        </div>
                        <div>
                            <div className="relapseQuestion">Content Relevance:</div>
                            <ContentRelevanceSlider handleChange={handleContentRelevance} min='1' max='10'/>
                        </div>
                        <div>
                            <div className="relapseQuestion">Today Content Takeaways</div>
                            <LearingContentTakeawaysField placeholder="What takeaways did you find? What do you want to learn more about?" rows="2" handleChange={handleLearingContentTakeaways}/>
                        </div>
                        <div>
                            <div className="relapseQuestion">Tomorrow Content?:</div>
                            <LearningContentRequest placeholder="What do you want the next digital wellness workout to focus on?" rows="2" handleChange={ handleContentRequest }/>
                            {/* <LearingContentTakeawaysField placeholder="What takeaways did you find? What do you want to learn more about?" rows="2" handleChange={handleLearingContentTakeaways}/> */}

                        </div>
                        {/* <input type="text" value={dailyGoalNotification} onChange={event => setDailyGoalNotifications(event.target.value)} /> <br />             */}
                    </div>
                </div>
            )


            /* <div>
            Morning Use: <input type="text" value={morningUse} placeholder="1-10 (1 as in poor 10 as in great)" onChange={event => setMorningUse(event.target.value)} /> <br />
            Afternoon Use: <input type="text" value={afternoonUse} placeholder="1-10 (1 as in poor 10 as in great)" onChange={event => setAfternoonUse(event.target.value)} /> <br />
            Night Use: <input type="text" value={nightUse} placeholder="1-10 (1 as in poor 10 as in great)" onChange={event => setNightUse(event.target.value)} /> <br />
            Current Confidence: <input type="text" value={currentConfidence} placeholder="Confidence in meeting goal, 1-10" onChange={event => setCurrentConfidence(event.target.value)} /> <br />
            <p>Prior Day Takeaways:</p> <textarea className="textinput" name="paragraph_text" cols="50" value={yesterdayTakeaways} onChange={event => setYesterdayTakeaways(event.target.value)}></textarea>
            </div> */
            setDailyJournalBody(
                <div className="learningFeedback">
                    <div className="audioJournal">
                        {/* <div className="relapseQuestion">When you will complete the goal by</div> */}
                        {/* <div className="audioJournalEdit">
                            <div className="relapseQuestion" style={{ marginTop: '1rem'}}>Suggested Daily Prompt</div>
                            <DailyPromptTextField id="dailyPrompt" name="dailyPrompt" label="Set Prompt" defaultValue={content.journal.content.textcontent} handleChange={handleDailyJournalPrompt} value={dailyPromptText} />
                        </div> */}
                        <div className="relapseQuestion" style={{textAlign: 'center', marginTop: '1rem'}}> 
                            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                <div style={{margin: '0.5rem'}}>Prompt:</div>
                                <button onClick={handleEditPrompt} style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}> 
                                    <img className="editBttn" src={ editBttn } alt="editBttn" />
                                    <div style={{margin: '0.3rem'}}>Edit</div>
                                </button>
                            </div>
                            <br/>
                            <div className="dailyAudioJournal" style={{textAlign: 'center'}}>{ content.journal.content.textcontent } </div>
                            <div className="audioJournalEdit" style={{ display: 'none', marginTop: '1rem'}}>
                                {/* <div className="relapseQuestion" style={{ marginTop: '1rem'}}>Update daily prompt</div> */}
                                <DailyPromptTextField label="Set Prompt" defaultValue={content.journal.content.textcontent} handleChange={handleDailyJournalPrompt} />
                            </div>
                        </div>
                        {/* <div>
                            <div className="relapseQuestion" style={{ marginTop: '1.6rem'}}>Suggested daily prompt</div>
                            <MateriaBasicTextField label="Set Prompt" defaultValue={content.journal.content.textcontent} handleChange={handleDailyGoalTitle} />
                        </div> */}
                        <div> <AudioRecorder saveAudio= {handleAudioState} /> </div>  
                        {/* Toggle Button / Text Mode */}
                        {/* <button
                            onClick={() => setShowTextJournal(!showTextJournal)}
                            className="w-full px-4 py-2 text-white bg-red-500 rounded-md hover:bg-red-600 transition"
                        >
                            {showTextJournal ? "Cancel Text Journal" : "Too loud to record?"}
                        </button>
                        {showTextJournal && (
                            <div className="mt-4 p-4 border rounded-md bg-gray-100">
                            <textarea
                                className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
                                placeholder="Write your thoughts here..."
                                value={textJournal}
                                onChange={handleTextChange}
                                rows="4"
                            ></textarea>

                            <button
                                className="mt-2 w-full px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition"
                            >
                                Save Journal Entry
                            </button>
                            </div>
                        )}                  */}
                    </div>
                    {/* <div className="audioJournalEdit"  style={{ display: 'none'}}>
                        <div>
                            <div className="relapseQuestion" style={{ marginTop: '1.6rem'}}>Suggested daily prompt</div>
                            <MateriaBasicTextField label="Set Prompt" defaultValue={content.journal.content.textcontent} handleChange={handleDailyJournalPrompt} />
                        </div>
                        <div className="formBttnContainer" >
                            <button className="popupButton" style={{ marginBottom: '1rem'}} onClick={handleUpdatePrompt} > Update </button>
                        </div>                  
                    </div> */}
                </div> 
            )
            setDailyGoalBody(
                <div className="learningFeedback">
                    <div className="container dailyGoal" style={{ flexDirection: 'column' }}>
                        {/* <input type="text" value={content.goal.content.textcontent} onChange={event => setDailyGoalTitle(event.target.value)} /> <br /> */}
                        {/* <p style={{ marginRight: '1.6rem', textAlign: 'center' }}> Daily Goal: { content.goal.content.textcontent } </p> */}
                        {/* <div>
                            <div className="relapseQuestion">Suggested daily goal</div>
                            <DailyGoalTextField id="dailyGoal" name="dailyGoal" label="Set Goal" defaultValue={content.goal.content.textcontent} handleChange={handleDailyGoalTitle} value={dailyGoalTitle}/>
                        </div> */}
                        <div className="relapseQuestion" style={{textAlign: 'center', marginTop: '1rem'}}> 
                            {/* Daily Goal<button onClick={handleEditGoal} style={{border:'none'}}> 
                                <img className="editBttn" src={ editBttn } alt="editBttn" />
                            </button>:<br/> */}
                            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                <div style={{margin: '0.5rem'}}>Daily Goal:</div>
                                <button onClick={handleEditGoal} style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}> 
                                    <img className="editBttn" src={ editBttn } alt="editBttn" />
                                    <div style={{margin: '0.3rem'}}>Edit</div>
                                </button>
                            </div>
                            <div className="dailyGoalSuggestion" style={{textAlign: 'center', marginTop: '1rem', marginBottom: '0.5rem'}}>{ content.goal.content.textcontent } </div>
                            <div className="dailyGoalEdit" style={{ display: 'none', marginTop: '1rem'}}>
                                {/* <div className="relapseQuestion" style={{ marginTop: '1rem'}}>Update daily prompt</div> */}
                                <DailyGoalTextField id="dailyGoal" name="dailyGoal" label="Set Goal" defaultValue={content.goal.content.textcontent} handleChange={handleDailyGoalTitle} value={dailyGoalTitle}/>
                            </div>
                        </div>
                        <div>
                            <div className="relapseQuestion">When you will complete the goal by</div>
                            <DailyGoalDueDate placeholder="Goal Due Date" handleChange={handleDailyGoalDue}/>
                        </div>
                        <div>
                            <div className="relapseQuestion">Why you want to reach this goal</div>
                            <GoalReasoningTextField placeholder="Think about how the goal fits in the bigger picture" rows="3" handleChange={handleDailyReason}/>
                        </div>
                        {/* <input type="text" value={dailyGoalNotification} onChange={event => setDailyGoalNotifications(event.target.value)} /> <br />             */}
                    </div>
                </div>
            )
            setDailyProgressBody(
                // <div className="dailySection"> 
                // <div>
                //     <div>
                //         <div className="relapseQuestion">Previous Goal Status</div>
                //         <MaterialStatusSelect/>
                //     </div>
                //     <div style={{ marginTop: '2rem' }}>
                //         <div className="relapseQuestion">Recent Tech Use:</div>
                //         <MaterialDiscreteSlider/>
                //     </div>
                //     <div>
                //         <div className="relapseQuestion">Takeaways</div>
                //         <MaterialMultilineTextField placeholder="Think about what you learned from the previous day and how you can make today better" rows="3"/>
                //     </div>
                //     {/* Previous Goal Status: <input type="text" value={currentConfidence} placeholder="Reduce screen time by an hour" onChange={event => setCurrentConfidence(event.target.value)} /> <br />
                //     Recent Tech Use: <input type="text" value={morningUse} placeholder="1-10 (1 as in poor 10 as in great)" onChange={event => setMorningUse(event.target.value)} /> 
                //     <p>Takeaways:</p> <textarea style={{ maxHeight: '2.5rem' }} className="textinput" name="paragraph_text" cols="10" value={yesterdayTakeaways} onChange={event => setYesterdayTakeaways(event.target.value)}></textarea> */}
                // </div>
                // </div>
                <div className="learningFeedback">
                    <div className="container" style={{ flexDirection: 'column' }}>
                        {/* <input type="text" value={content.goal.content.textcontent} onChange={event => setDailyGoalTitle(event.target.value)} /> <br /> */}
                        {/* <div>
                            <div className="relapseQuestion">Previous Goal Status</div>
                            <MaterialStatusSelect handleChange={handlePreviousGoalStatus}/>
                        </div> */}
                        <div>
                            <p className="questionInfo">  Rate below, from 1 (Poor) to 10 (Great).</p>
                        </div>
                        <div>
                            <div className="relapseQuestion">Current Confidence:</div>
                            <DailyCurrentConfidenceSlider handleChange={handleProgressConfidence} min='1' max='10'/>
                        </div>
                        <div>
                            <div className="relapseQuestion">Recent Tech Use:</div>
                            <DailyRecentTechUseSlider handleChange={handleRecentTechUse} min='1' max='10'/>
                        </div>
                        <div>
                            <div className="relapseQuestion">Day Takeaway / Insight</div>
                            <ProgressTakeawaysTextField placeholder="Think about what you learned from the previous day and how you can make today better" rows="2" handleChange={handleProgressTakeaways}/>
                        </div>
                        {/* <input type="text" value={dailyGoalNotification} onChange={event => setDailyGoalNotifications(event.target.value)} /> <br />             */}
                    </div>
                </div>
            )
            setDailyVisualization(
                <div className="learningFeedback">
                    <div>
                        <p className="questionInfo"> Reflect on the big goal you set. Picture the person you became as you achieve it. Rate below, from 1 (Far) to 10 (Close).</p>
                    </div>
                    <div>
                        <div className="relapseQuestion">How close are you that version of you?:</div>
                        <DailyVizSlider handleChange={handleRecentTechUse} min='1' max='10'/>
                    </div>
                    <div>
                        <div className="relapseQuestion">Reflection</div>
                        <DailyVizReflectionField placeholder="This is a space to reflect on your progress. How are you closer?" rows="3" handleChange={handleProgressTakeaways}/>
                    </div>
                </div> 
            )
            const nowLearning = new Date();
            const todayStartLearning = new Date(nowLearning.getFullYear(), nowLearning.getMonth(), nowLearning.getDate());
            const streakValLearning = Math.max(0, Number(currentWorkoutStreak) || 0);
            const learningSuccessCurrentStreak = currentWorkoutStreak;
            const learningSuccessLast7Days = [];
            for (let daysAgo = 6; daysAgo >= 0; daysAgo--) {
                const d = new Date(todayStartLearning);
                d.setDate(todayStartLearning.getDate() - daysAgo);
                const isToday = daysAgo === 0;
                const complete = streakValLearning > 0 && daysAgo < streakValLearning;
                learningSuccessLast7Days.push({
                    complete,
                    isToday,
                    labelFr: FR_WEEKDAY_SHORT[d.getDay()],
                });
            }

            setLearningSuccess(
                <div className="learningFeedback">
                    <div>
                        <p id="learning-success-info-text" className="questionInfo"> Keep making progress one workout at a time. The key to success is consistency. </p>
                    </div>
                    <div>
                        <div className="dummy-positioning d-flex">  
                            <div className="success-icon">
                                <div className="success-icon__tip"></div>
                                <div className="success-icon__long"></div>
                            </div>
                        </div>
                    </div>
                    {/* <div className='learningProgressBody' style={{display:'none'}}>
                        <div className='learningProgressContainer'>
                            <img className="learningProgressIcon" src={progressFire} alt="Logo" />
                            <img className="learningProgressIcon incompleteIcon" src={progressFire} alt="Logo" />
                            <img className="learningProgressIcon incompleteIcon" src={progressFire} alt="Logo" />
                            <img className="learningProgressIcon incompleteIcon" src={progressFire} alt="Logo" />
                            <img className="learningProgressIcon incompleteIcon" src={progressFire} alt="Logo" />
                        </div>
                        <div>Goal: Use Trampoline 5 times this week</div>
                    </div> */}
                    <div className='learningProgressBody' style={{display:'none'}}>
                    <StreakCelebrateBlock
                        streak={learningSuccessCurrentStreak}
                        days={learningSuccessLast7Days}
                        onContinue={handleCloseLearningPopup}
                    />
                </div>
                    {/* <div>
                        {isExploding && <ConfettiExplosion {...largeProps} />}
                    </div> */}
                    {/* <button className="button" onClick={() => setIsExploding(!isExploding)}>
                        {isExploding && <ConfettiExplosion {...largeProps}/>}
                        <span>small</span>
                    </button> */}
                    <div className="formBttnContainer" style={{ bottom: '2rem' }}>
                        <button className="popupButton" onClick={() => {window.open("https://trampolinehealth.circle.so/join?invitation_token=3cff0ae5ec294f740a32bac3219619a5e2e27ed9-a1faea1f-4698-44e9-be22-47c01f9a128d", "_blank");}} >Share with Community</button>
                        <button className="popupButton" style={{ marginTop: '1rem'}} onClick={handleCloseLearningPopup} > Done </button>
                    </div>
                </div> 
            )
            setLearningProgress(
                <div className="learningFeedback">
                    <div>
                        <p className="questionInfo"> List of Progress </p>
                    </div>
                    <div>
                        <div className="dummy-positioning d-flex">  
                            <div className="success-icon">
                                <div className="success-icon__tip"></div>
                                <div className="success-icon__long"></div>
                            </div>
                        </div>
                    </div>
                    <div>
                        progress fire emojis boyyyy
                    </div>
                    <div className="formBttnContainer" style={{ bottom: '2rem' }}>
                        {/* <button className="homeBttn" onClick={handleOpenRelapsePopup} >Home</button> */}
                        <button className="popupButton" style={{ marginTop: '1rem'}} onClick={handleChatNavigate} >Chat Support</button>
                    </div>
                </div> 
            )
            if (loadingSpinner) {
                    loadingSpinner.style.display = 'none'; // Example: Change the text color
            }
            setLoading(false);
            setWeeklyChartLoading(false);
            // alert('donee yo1')
        }).catch(error => {
            //TODO: fix error of receiving null error
            ////console.log('returned error')
            console.error(error);
            setLoading(false);
            setWeeklyChartLoading(false);
            setWeeklyBarChartData([]);
            if (loadingSpinner) {
                ////console.log('deleting donute')
                loadingSpinner.style.display = 'none'; // Example: Change the text color
            }
            if (error.response) {
                // The request was made, but the server responded with a status code
                // outside the range of 2xx
                console.error('Error Response:', error.response);
                 // alert('donee yo2')
                 return
                setErrorMessage('Sorry the server is down. Please try again later.');
                if(error.response.status === 403 ){
                    setErrorMessage(error.response.data.message);
                }
                else if(error.response.status === 401 ){
                    ////console.log('need to login again')
                    navigate('/login')
                }
                else{
                    setErrorMessage('Sorry the server is down. Please try again later.');

                }
            } else if (error.request) {
                // The request was made, but no response was received
                console.error('No Response:', error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.error('Error:', error.message);
            }
        })
    }

    const onLearningOptionChange = e => {
        setLearningFeedback(e.target.value)
    }
    const onPromptOptionChange = e => {
        setPromptFeedback(e.target.value)
    }
    const onGoalOptionChange = e => {
        setGoalFeedback(e.target.value)
    }

    // function swapPopupData() {
    //     questions = questionsRelapse
    // }

    function stringToHTML (str) {
        // If DOMParser is supported, use it
        let support = true
        if (!window.DOMParser) support = false;
        let parser = new DOMParser();
        try {
            parser.parseFromString('x', 'text/html');
        } catch(err) {
            support = false;
        }
        if (support) {
            let parser = new DOMParser();
            var doc = parser.parseFromString(str, 'text/html');
            ////console.log('yo7', dom)
            return doc.body;
        }

        // Otherwise, fallback to old-school method
        var dom = document.createElement('div');
        dom.innerHTML = str;
        ////console.log('yooo')
        ////console.log('yo7', dom)
        return dom;
    };

    function randomArrVal(arr){
        return arr[Math.floor(Math.random() * arr.length)];
    }

    function fetchNextContent(responseObj, progress){
        let content = {
            'learning': {},
            'journal': {},
            'goal': {}
        };

        const dailyPrompt = responseObj['Prompt']
        const dailyGoal = responseObj['Goal']
        const dailyLearning = responseObj['Learning']
        
        const moduleContent = dailyLearning.concat(dailyGoal, dailyPrompt);
        
        ////console.log('concat', moduleContent)

        //TODO: fix the backend so it's changed to content name instead of sk
        for (let index = 0; index < moduleContent.length; index++) {
            const element = moduleContent[index];
            ////console.log('element sk', element.sk)
            ////console.log('element content name', element.contentname)
            ////console.log('progress sk -- should be content name', progress.learning.sk)
            if(element.sk.includes('Learning')){
                if(element.contentname === progress.learning.sk){
                    content.learning = element
                }
            }
            if(element.sk.includes('Prompt')){
                if(element.contentname === progress.journal.sk){
                    content.journal = element
                }
            }
            if(element.sk.includes('Goal')){
                if(element.contentname === progress.goal.sk){
                    content.goal = element
                }
            }
            
        }

        return content
    }

    //TODO: move this to an environment variable
    const requestConfig = {
        headers: {
            'x-api-key': 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB'
        }
    }

    const contentParams = {
        mode: 'default',
        test: 'hi'
    };


    // //Testing set workout date to a specific time
    // // Convert the local ISO string back into a Date object
    // const localDateObj = new Date(localISOTime);

    // // Add one day using the setDate/getDate approach.
    // // This method automatically handles month/year boundaries.
    // localDateObj.setDate(localDateObj.getDate() + 2);

    // // Convert back to an ISO string (and remove the trailing 'Z' if you want to stick with your format)
    // const nextDayLocalISOTime = localDateObj.toISOString().slice(0, -1);
    // let testDate = nextDayLocalISOTime

    const requestBody = {
        username: username,
        token: token,
        contentParams: contentParams,
        date: date
    }

    useEffect(() => {    

        //Check if the user is coming from the onboarding page
        console.log('location state', location.state)
        if (location.state?.fromOnboarding) {
            console.log('coming from onboarding')
            console.log('learningHandler:', learningHandler); // is it a function?
            try {
                setTimeout(() => {
                    learningHandler();
                }, 3500);
            } catch (e) {
                console.error('learningHandler failed:', e);
            }
        }
    
        async function initializeData() {
            // Make sure the spinner is shown immediately
            if (loadingSpinner) {
                // alert('here')
                loadingSpinner.style.display = 'inline-block';
            }

            
            // Use async/await to control the order
            await time(setGoalSubmissionPopup, 'setGoalSubmissionPopup');
            await time(setRelapseLog, 'setRelapseLog');
            await time(setRegulationLog, 'setRegulationLog');
            await time(fetchDailyContent, 'fetchDailyContent');
            
            

        }

        // Start the initialization (no blocking)
        initializeData();
    }, []) 


    let questionsEmotionalRegulation = [
        // {
        //     question: 'Ride the Wave',
        //     assets: regulationIntro,
        //     subheading: 'Content Takeaways',
        //     input: '<textarea className="textinput" name="paragraph_text" cols="50" value={contentFeedback} onChange={event => setContentFeedback(event.target.value)}></textarea>'

        // },
        // {
        //     question: 'Bodyscan',
        //     assets: regulationExercise,
        // },
        {
            question: 'Breathing Exercise',
            assets: motivationPrompts,
        },
        {
            question: 'Prevention Plan',
            assets: relapsePlan,
        }
        // Add more questions as needed
    ];

    //Popup
    let questionsLearning = [
        {
            question: 'Learning Content',
            assets: learningContent,
            subheading: 'Content Takeaways',
            input: '<textarea className="textinput" name="paragraph_text" cols="50" value={contentFeedback} onChange={event => setContentFeedback(event.target.value)}></textarea>'

        },
        {
            question: 'Learning Feedback',
            assets: contentFeedback,
        },
        {
            question: 'Audio Journal Entry',
            assets: dailyJournalBody,
        },
        {
            question: 'Daily Goal',
            assets: dailyGoalBody,
        },
        {
            question: 'Progress Entry',
            assets: dailyProgressBody,
        },
        // {
        //     question: 'Reflect',
        //     assets: dailyVisualization,
        // },
        {
            question: 'Success!',
            assets: learningSuccess,
        },
        {
            question: 'Learning Progress',
            assets: learningProgress,
        },
        // Add more questions as needed
    ];

    //Popup
    let questionsRelapse = [
        {
            question: 'Set Back Support',
            assets: relapseIntro,
            subheading: 'Test',
            input: '<textarea className="textinput" name="paragraph_text" cols="50" value={contentFeedback} onChange={event => setContentFeedback(event.target.value)}></textarea>'
        },
        {
            question: 'Progress Entry',
            assets: relapseTime,
        },
        // {
        //     question: 'Progress Entry',
        //     assets: relapseBackground,
        // },
        {
            question: 'Progress Entry',
            assets: relapseInformation,
        },
        {
            question: 'Progress Entry',
            assets: relapseWhy,
        },
        {
            question: 'Progress Entry',
            assets: relapseImpact,
        },
        {
            question: 'Progress Entry',
            assets: relapseImprovement,
        },
        {
            question: 'Success!',
            assets: relapseSuccess,
        },
        {
            question: 'Prevention Plan',
            assets: relapsePlan,
        }
    ];
    
    //Popup
    let questionsGoalSubmit = [
         {
            question: 'Complete Daily Goal',
            assets: goalSubmitUI,
        },
        {
            question: 'Success!',
            assets: goalPostSubmitUI,
        },
    ];

    const handleRelapseSupport = () => {
        ////console.log('handling relapse support')
        setShowPopup(true);
        document.getElementById('learning-popup').style.display = "none";
        document.getElementById('relapse-popup').style.display = "block";
        document.getElementsByClassName("popupContainer")[1].style.visibility =  "visible"
    };

    const handleNextQuestion = () => {
        setCurrentQuestion(currentQuestion + 1);
    };

    function parseNumber(text) {
        if (!text) return NaN;
        const cleaned = text.replace(/[^\d.-]/g, "");
        return Number(cleaned);
    }

    const completeGoal = () => {

        setCurrentQuestion(currentQuestion + 1);
        setGoalCompleted(!goalCompleted)
        let newGoalCount = goalCount+1
        console.log('new goal count: ', newGoalCount)
        setGoalCount(newGoalCount)
        console.log('new goal count react: ', goalCount)
        // goalCompletedInput, goalCompletionDateInput, goalCompletedReflectionInput
        // ✅ Directly get the values of the inputs using JavaScript
        const goalCompletedInput = document.querySelector("#goalCompletedInput")?.value || "";
        const goalReflectionInput = document.querySelector("#goalReflectionInput")?.value || "";
        const goalCompletionDateInput = document.querySelector("#goalCompletionDateInput")?.value || "";

        console.log("Goal Completed Input:", goalCompletedInput);
        console.log("Goal Reflection Input:", goalReflectionInput);
        console.log("Goal Completion Date Input:", goalCompletionDateInput);

        // ✅ Use the values directly for your logic
        // Example: Send to API
        // updateGoalStatus(goalCompletedInput, goalReflectionInput, goalCompletionDateInput);
        
        // Hot hot fix for the goal counter. need to fix this and refact ASAP
        const selector = "#homeContainer > div.progressContainer > div:first-child > div > div.progressCounter";
        const el = document.querySelector(selector);
        if (!el) return;

        const n = parseNumber(el.textContent);
        console.log('Current amount of goals on the log: ', n)
        if (!Number.isFinite(n)) return;

        const nNew = String(n + 1)
        console.log('Current amount of goals on the log post plus one: ', nNew)
        el.textContent = nNew;
        
        updateGoalStatus(!goalCompleted, goalCompletedInput, goalCompletionDateInput, goalReflectionInput)
    };

    // const handleRelapseNextQuestion = () => {
    //     ////console.log(currentQuestion)
    //     if(currentQuestion===6){
    //         //console.log('relapse update')
    //         setRelapseSuccess(
    //             <div className="learningFeedback">
    //                 <div>
    //                     <p className="questionInfo"> Getting back on track starts with self-compassion. Let's grow from this setback. Well done. </p>
    //                 </div>
    //                 <div>
    //                     <h4>Lesson:</h4>
    //                     <p id="relapseImprovementTextBody"> {relapseImprovementText} </p>
    //                 </div>
    //                 <div className="formBttnContainer" style={{bottom:'3rem'}}>
    //                     <button className="popupButton" onClick={() => {window.open("https://trampolinehealth.circle.so/c/goals-takeaways/", "_blank");}} > Make Post </button>
    //                     <button className="popupButton" onClick={() => {navigator.clipboard.writeText(relapseImprovementText);}}   style={{ marginTop: '1rem' }} >Copy Text</button>
    //                     <button className="popupButton" style={{ marginTop: '1rem' }} onClick={handleChatNavigate} >Chat Support</button>
    //                 </div>
    //             </div> 
    //         )
    //     }
    //     setCurrentQuestion(currentQuestion + 1);
    // };

    const handleRegulationMotivation = () => {
        setCurrentQuestion(currentQuestion + 2);
    };

    const handleRegulationBack = () => {
        setCurrentQuestion(0);
    };

    // const handleNextQuestionLearning = () => {
    //     setCurrentQuestion(currentQuestion + 1);
    //     //console.log(currentQuestion)
    //     if(currentQuestion === 4){
    //         setTimeout(()=>{
    //             document.getElementsByClassName('success-icon')[0].style.display = 'none'
    //             document.getElementsByClassName('learningProgressBody')[0].style.display = 'block'
    //         }, 2000)
    //     }
    // };

    const handlePreviousQuestion = () => {
        setCurrentQuestion(currentQuestion - 1);
        ////console.log('relapse test: ', currentQuestion)
    };

    const handleRelapsePreventionPlan = () => {
        // alert('sending over to relapse plan')
        setCurrentQuestion(currentQuestion + 2);
        // ////console.log('relapse test: ', currentQuestion)
    };

    const handleOverehelmedPreventionPlan = () => {
        setCurrentQuestion(currentQuestion + 1);
        // ////console.log('relapse test: ', currentQuestion)
    };

    const handleSelectOption = (selectedOption) => {
        // Update the selected option as the answer for the current question
        const updatedAnswers = [...answers];
        updatedAnswers[currentQuestion] = selectedOption;
        setAnswers(updatedAnswers);
    };

    const handleInputChange = (inputValue) => {
        // Update the input value as the answer for the current question
        const updatedAnswers = [...answers];
        updatedAnswers[currentQuestion] = inputValue;
        setAnswers(updatedAnswers);
    };

    const learningHandler = () => {
        console.log('in learning handler')
        isUserLoggedIn().then((isLoggedIn) => {
            if (!isLoggedIn) {
                // navigate('/login'); // or use your router
                console.log('log out')
            }
        });
        document.getElementById('homeContainer').style.display = 'none'
        document.getElementById('learningContainer').style.display = 'block'
    }

    const homeHandler = () => {
        document.getElementById('learningContainer').style.display = 'none'
        document.getElementById('homeContainer').style.display = 'block'
    }


    const handleChatNavigate = () => {
        // Update the input value as the answer for the current question
        // //console.log('navigate chat')
        navigate('/chat')
    };

    const handleGymNavigate = () => {
        // Update the input value as the answer for the current question
        // //console.log('navigate chat')
        navigate('/wellness-gym')
    };

    const handleSubmitRelapse = () => {
        //test to make sure all of the data is correct
        //reload 
        // alert("Sending out relapse")

        setRelapseSuccess(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo"> Getting back on track starts with self-compassion. Let's grow from this setback. </p>
                </div>
                <div>
                    {/* <h4 style={{textAlign:'center'}}>Lesson:</h4> */}
                    <p id="relapseImprovementTextBody" style={{ marginLeft: '1.5rem', marginRight: '1.5rem'}}> <b>Insight: </b> {relapseImprovementText} </p>
                </div>
                <div className="formBttnContainer" style={{bottom:'3rem'}}>
                    <button className="popupButton" onClick={() => {navigator.clipboard.writeText(relapseImprovementText);}}   style={{ marginTop: '1rem' }} >Copy Text</button>
                    <button className="popupButton" style={{ marginTop: '1rem' }} onClick={() => {window.open("https://trampolinehealth.circle.so/join?invitation_token=3cff0ae5ec294f740a32bac3219619a5e2e27ed9-a1faea1f-4698-44e9-be22-47c01f9a128d", "_blank");}} > Community Support </button>
                    {/* <button className="popupButton" onClick={() => {{handleRelapsePreventionPlan()}}} style={{ marginTop: '1rem' }} >Prevention Plan</button> */}
                    {/* <button className="popupButton" style={{ marginTop: '1rem' }} onClick={handleChatNavigate} >Chat Support</button> */}
                </div>
            </div> 
        )
  
        
        const requestConfig = {
            headers: {
                'x-api-key': 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB'
            }
        }

        //need to rethink content feedback - MUST DO BEFORE BETA START
        //TODO: FIX THE DATE TIME SUBMISSION TYPE WHY AM I USING EPOCH VS DATETIME STRING NEED UNIFORMITY
        const requestBody = {
            username: username,
            token: token,
            date: dateObj.getTime(),
            problematicUseStart: new Date(problematicUseStart).getTime(),
            problematicUseEnd: new Date(problematicUseEnd).getTime(),
            relapseBehaviors: relapseBehaviors,
            relapseDevices: relapseDevices,
            relapseDescription: relapseDescription,
            relapseReasoning: relapseReasoning,
            relapseImpactValue: relapseImpactValue,
            relapseImpactDescriptionValue: relapseImpactDescriptionValue,
            relapseImprovementText: relapseImprovementText
        }

        //console.log('pre-request', requestBody)
        // return
        axios.post(logSubmitUrl, requestBody, requestConfig).then(response => {
            //TODO add the alerts and blah blah
            //console.log('relapse data submitted correctly')
            
        }).catch(error => {
            //console.log('relapse submission error')
            //console.log(error)
            //TODO: fix error of receiving null error
            if(error.response.status === 401 || error.response.status === 403 ){
                setErrorMessage(error.response.data.message);
            }
            else{
                setErrorMessage('Sorry the server is down. Please try again later.');

            }
        })

        // Show a success message or close the popup form
        document.getElementsByClassName("popupButtonGroup")[0].style.visibility =  "hidden"
        handleNextQuestion()

        //submit stuff to the database
    };

    async function uploadFile(signedUrl, fileContent, fileType) {
        const response = await fetch(signedUrl, {
            method: 'PUT',
            body: fileContent
        });

        if (response.ok) {
            //console.log('File uploaded successfully!');
        } else {
            console.error('Error uploading file:', response.statusText);
        }
        return response.ok
    }

    async function handleSubmitJournalEntry () {
        
        const requestConfig = {
            headers: {
                'x-api-key': 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB'
            }
        }

        //need to rethink content feedback - MUST DO BEFORE BETA START
        const requestBody = {
            username: username,
            token: token,
            date: dateObj.getTime(),
            action: 'fetch-s3-url',
            timestamp: Date.now(),
            contentType: 'audio-journal-entry',
            fileType: 'audio/mpeg',
        }

        //console.log('pre-request for journal entry', requestBody)

        let uploadStatus = false;
        try {
            // Make the POST request to get the upload URL
            const response = await axios.post(userGeneratedUploadUrl, requestBody, requestConfig);

            //console.log('journal data submitted correctly');
            //console.log(response);

            // Use the signed URL to upload the file
            uploadStatus = await uploadFile(response.data.uploadUrl, journalAudio, 'audio/mpeg');

            // Return the result
            return {
                fileName: response.data.fileName,
                uploadStatus: uploadStatus
            };
        } catch (error) {
            //console.log('journal submission error');
            //console.log(error);

            // Handle errors
            if (error.response?.status === 401 || error.response?.status === 403) {
                setErrorMessage(error.response.data.message);
            } else {
                setErrorMessage('Sorry the server is down. Please try again later.');
            }

            // Return an error response
            return {
                fileName: 'error uploading file',
                uploadStatus: uploadStatus
            };
        }

    };


    async function handleSubmitLearning(event) {
        event.preventDefault();
        // Show a success message or close the popup form
        document.getElementsByClassName("popupButtonGroup")[0].style.visibility =  "hidden"
        handleNextQuestion()
        // //console.log(currentQuestion)
        setIsExploding(true)
        setWorkoutCompleted(true)
        const response = await handleSubmitJournalEntry()
        //console.log('post file submission response: ', response)
        //test to make sure we have all the data
        // //console.log('got da journal title', dailyPromptText)
        // //console.log('got da journal audio', journalAudio)
        // //console.log('got da goal title', dailyGoalTitle)
        // //console.log('got the goal date', dailyGoalDate)

        //getting the date in the right time zone and day
        // const localizedGoalTime = new Date(0, 0, 0, hours, minutes);
        let goalIsoString = ""
        if (dailyGoalDate instanceof Date && !isNaN(dailyGoalDate)) {
            const currentDate = new Date();
            
            if (dailyGoalDate < currentDate) {
            
                //console.log('date is later')
                // Change the date to one day after the current date and time, preserving the time
                dailyGoalDate.setDate(dailyGoalDate.getDate() + 1)
                //console.log('later date: ', dailyGoalDate)
            }
            goalIsoString = dailyGoalDate.toISOString();

        }

        // //console.log('got the goal ISO', goalIsoString)
        // //console.log('got the goal reason', dailyGoalReason)
        // //console.log('got previous goal status', pastGoalStatus)
        // //console.log('got recent tech use', recentTechUse)
        // //console.log('got takeaways', yesterdayTakeaways)

        // //console.log('got da content relevance', contentRelevance)
        // //console.log('got da content request', contentRequest)
        // //console.log('got da content takeaways', learningContentTakeaways)
    
        const learningContentFeedback = {
            contentRelevance: contentRelevance,
            contentRequest: contentRequest,
            learningContentTakeaways: learningContentTakeaways
        }


        // //console.log('confettiiiii')

        setTimeout(()=>{
            document.getElementsByClassName('success-icon')[0].style.display = 'none'
            document.getElementsByClassName('learningProgressBody')[0].style.display = 'block'
            document.getElementById('learning-success-info-text').style.display = 'none'
        }, 3300)
        //submit stuff to the database
        
        //TODO: move this to an environment variable
        const requestConfig = {
            headers: {
                'x-api-key': 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB'
            }
        }

        //TODO: make backend changes to make this possible
        //Need to change this so it is relevant for videos and for text content

        let progress = dailyLearning.progress + 300
        let completed = true
        //Need to make sure this links up with the fetch
        let mode = 'default'
        const start = dailyLearning.progress
        
        if (progress > dailyLearning.length){
            progress = dailyLearning.length
            completed = true
        }

        // //Testing set workout date to a specific time
        // // Convert the local ISO string back into a Date object
        // const localDateObj = new Date(localISOTime);

        // // Add one day using the setDate/getDate approach.
        // // This method automatically handles month/year boundaries.
        // localDateObj.setDate(localDateObj.getDate() + 1);

        // // Convert back to an ISO string (and remove the trailing 'Z' if you want to stick with your format)
        // const nextDayLocalISOTime = localDateObj.toISOString().slice(0, -1);
        // let testDate = nextDayLocalISOTime

        //need to rethink content feedback - MUST DO BEFORE BETA START

        const workoutDurationMinutes = Math.max(
            0,
            Math.round(((Math.max(0, Number(progress) - Number(start))) / 60) * 10) / 10
        );
       
        const requestBody = {
            username: username,
            token: token,
            date: date,
            mode: mode,
            workoutType: 'daily_workout',
            durationMinutes: workoutDurationMinutes,
            completedAt: new Date().toISOString(),
            timestamp: Date.now(),
            exercise_type: 'daily_workout',
            learningContent: {
                contentFeedback: learningContentFeedback,
                dailyLearning: dailyLearning,
                status: {
                    completed: completed,
                    start: start,
                    progress: progress
                }
            },
            journalContent: {
                journalAudio: response.fileName,
                dailyPrompt: dailyPrompt
            },
            goalContent: {
                "dailyGoal": dailyGoal,
                "selectedGoal": {
                    "textcontent": dailyGoalTitle, 
                    "notifications": dailyGoalNotification,
                    "goalduedate": dailyGoalDate,
                    "goalISO": goalIsoString,
                    "goalreason": dailyGoalReason
                }
            },
            progressContent: {
                "previousgoalstatus": pastGoalStatus,
                "recenttechuse": recentTechUse,
                "yesterdaytakeaways": yesterdayTakeaways,
                "progressConfidence": progressConfidence
            }

            // //console.log('got the goal date', dailyGoalDate)
            // //console.log('got the goal reason', dailyGoalReason)
            // //console.log('got previous goal status', pastGoalStatus)
            // //console.log('got recent tech use', recentTechUse)
            // //console.log('got takeaways', yesterdayTakeaways)
            // currentConfidence: currentConfidence,
            // yesterdayTakeaways: yesterdayTakeaways
        }

        //console.log('request body -- learning woot', requestBody)

        axios.post(dailySubmitUrl, requestBody, requestConfig).then(response => {
            //TODO add the alerts and blah blah
            setUserGoal({ "textcontent": dailyGoalTitle, "notifications": dailyGoalNotification})
            document.getElementById('dailyGoalText').innerText = dailyGoalTitle
            let timeline = document.getElementsByClassName('learningTimeline')
            for (let index = 0; index < timeline.length; index++) {
                timeline[index].style.backgroundColor = 'darkgrey'
            }

            
            
        }).catch(error => {
            //console.log('error')
            //console.log(error)
            //TODO: fix error of receiving null error
            if(error.response.status === 401 || error.response.status === 403 ){
                setErrorMessage(error.response.data.message);
            }
            else{
                setErrorMessage('Sorry the server is down. Please try again later.');

            }
        })
    };
    const handleOpenLearningPopup = () => {
        setShowPopup(true);
        document.getElementById('learning-popup').style.display = "block";
        document.getElementsByClassName("popupContainer")[0].style.visibility =  "visible"
        document.getElementsByClassName("popupButtonGroup")[0].style.visibility =  "visible"
    };

    const handleOpenRelapsePopup = () => {
        isUserLoggedIn().then((isLoggedIn) => {
            if (!isLoggedIn) {
                navigate('/login'); // or use your router
            }
        });
        setShowPopup(true);
        document.getElementById('relapse-popup').style.display = "block";
        document.getElementsByClassName("popupContainer")[1].style.visibility =  "visible"
        document.getElementsByClassName("popupButtonGroup")[1].style.visibility =  "visible"
    };

    const handleOpenRegulationPopup = () => {
        setShowPopup(true);
        document.getElementById('regulation-popup').style.display = "block";
        document.getElementsByClassName("popupContainer")[2].style.visibility =  "visible"
        document.getElementsByClassName("popupButtonGroup")[2].style.visibility =  "visible"
    };

    const handleCloseLearningPopup = () => {
        setShowPopup(false);
        setCurrentQuestion(0); // Reset the current question when the popup is closed
        setAnswers([]); // Clear the answers when the popup is closed
        document.getElementsByClassName("popupContainer")[0].style.display =  "none"
        document.getElementsByClassName("popupContainer")[0].style.visibility =  "hidden"

    };

    const handleOpenGoalSubmitPopup = () => {
        setShowPopup(true);
        // alert('here')
        document.getElementById('goal-submit-popup').style.display = "block";
        document.getElementsByClassName("popupContainer")[3].style.visibility =  "visible"
        document.getElementsByClassName("popupButtonGroup")[3].style.visibility =  "visible"
    };

    const handleCloseGoalSubmitPopup = () => {
        setShowPopup(false);
        setCurrentQuestion(0); // Reset the current question when the popup is closed
        setAnswers([]); // Clear the answers when the popup is closed
        document.getElementsByClassName("popupContainer")[3].style.display =  "none"
        document.getElementsByClassName("popupContainer")[3].style.visibility =  "hidden"

    };

    const handleEditPrompt = () => {
        //console.log('editing prompt...')
        document.getElementsByClassName("dailyAudioJournal")[0].style.display =  "none"
        document.getElementsByClassName("audioJournalEdit")[0].style.display =  "block"
    };

    const handleEditGoal = () => {
        //console.log('editing goal...')
        document.getElementsByClassName("dailyGoalSuggestion")[0].style.display =  "none"
        document.getElementsByClassName("dailyGoalEdit")[0].style.display =  "block"
    };

    const handleUpdatePrompt = () => {
        //console.log('dailyprompttextttt', dailyPromptText)
        document.getElementsByClassName("dailyAudioJournal")[0].innerText =  dailyPromptText
        document.getElementsByClassName("audioJournalEdit")[0].style.display =  "none"
        document.getElementsByClassName("audioJournal")[0].style.display =  "block"
    };


    const handleCloseRegulationPopup = () => {
        setShowPopup(false);
        setCurrentQuestion(0); // Reset the current question when the popup is closed
        setAnswers([]); // Clear the answers when the popup is closed
        document.getElementsByClassName("popupContainer")[2].style.display =  "none"
        document.getElementsByClassName("popupContainer")[2].style.visibility =  "hidden"
    }

    const handleSubmitLearningClosePopup = () => {
        // //console.log('lesss navigate to the home screen homes')
        setShowPopup(false);
        setCurrentQuestion(0); // Reset the current question when the popup is closed
        setAnswers([]); // Clear the answers when the popup is closed
        document.getElementsByClassName("popupContainer")[0].style.display =  "none"
        document.getElementsByClassName("popupContainer")[0].style.visibility =  "hidden"
                        // <h5 id="todayInfo"> {todayString} (approx. 20 mins.)</h5>
        document.getElementById('todayInfo').innerText = todayString + " (completed)"

        // navigate('/home-demo');

    };

    const handleCloseRelapsePopup = () => {
        setShowPopup(false);
        setCurrentQuestion(0); // Reset the current question when the popup is closed
        setAnswers([]); // Clear the answers when the popup is closed
        document.getElementsByClassName("popupContainer")[1].style.display =  "none"
        document.getElementsByClassName("popupContainer")[1].style.visibility =  "hidden"

    };

    const renderFormRegulation = () => {
        try{
            const currentQ = questionsEmotionalRegulation[currentQuestion];
            const { question, options } = currentQ;
             return (
                <div className="formContainer">
                    <div className="daily-popup-top-right">
                        <button type="button" className="landing-onboarding-top-close" onClick={handleCloseRegulationPopup} aria-label="Close popup">x</button>
                    </div>
                    <h2 className="onboarding-popup-title">{question}</h2>
                    {currentQ.assets}
                    <div className="popupButtonGroup">
                    {(currentQuestion > 0 && currentQuestion < questionsEmotionalRegulation.length - 2) && (
                        // <button className="popupNavigationBttn" onClick={handlePreviousQuestion}>Previous</button>
                        <button className="popupNavigationBttn" onClick={handleRegulationBack} style={{border:'none', background: 'none'}}>
                            <img className="previousBttn" src={nextBttn} alt="previousBttn" />
                        </button>
                    )}
                    {/* {currentQuestion < questionsEmotionalRegulation.length - 2 ? (
                        <button className="popupNavigationBttn" onClick={handleNextQuestion} >Next</button>
                    ) : (
                        <button id="learningSubmit" className="popupNavigationBttn" onClick={handleChatNavigate} >Chat</button>
                    )} */}
                    {currentQuestion > 0 && currentQuestion < questionsEmotionalRegulation.length - 2 ? (
                        <button type="button" className="homeBttn onboarding-pill-btn" aria-label="Next step" onClick={handleNextQuestion}>
                            <svg width="20" height="20" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                                <path d="M3 7h8M7 3l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                            </svg>
                        </button>
                    ) : (
                        null
                    )}
                    {/* {currentQuestion >= questionsEmotionalRegulation.length - 2 ? (
                        <button id="relapseSubmit" className="popupNavigationBttn" onClick={handleChatNavigate}>Chat</button>
                    ) : (
                        null
                    )} */}
                    </div>
                </div>
            );
        
        }
        catch (err){
            //console.log('some error yo -- need to fix this: ', err)
        }
        
    };

    const renderFormLearning = () => {
        try{
            const currentQ = questionsLearning[currentQuestion];
            const { question, options } = currentQ;
             return (
                <div className="formContainer">
                    <div className="daily-popup-top-right">
                        {currentQuestion < questionsLearning.length - 1 ? (
                            <button type="button" className="landing-onboarding-top-close" onClick={handleCloseLearningPopup} aria-label="Close popup">x</button>
                        ) : (
                            <button type="button" className="landing-onboarding-top-close" onClick={handleSubmitLearningClosePopup} aria-label="Close popup">x</button>
                        )}
                    </div>
                    <h2 className="onboarding-popup-title">{question}</h2>
                    {currentQ.assets}
                    <div className="popupButtonGroup">
                    {currentQuestion > 0 && currentQuestion < questionsLearning.length - 2 ? (
                        <button className="popupNavigationBttn" onClick={handlePreviousQuestion} style={{border:'none', background: 'none'}}>
                            <img className="previousBttn" src={nextBttn} alt="previousBttn" />
                        </button>
                    ) : (
                        null
                    )}
                    {/* {currentQuestion < questionsLearning.length - 2 ? (
                        <button className="popupNavigationBttn" onClick={handleNextQuestion} >Next</button>
                    ) : (
                        <button id="learningSubmit" className="popupNavigationBttn" onClick={handleSubmitLearning} >Submit</button>
                    )} */}
                    {currentQuestion >= 0 && currentQuestion < questionsLearning.length - 3 ? (
                        <button type="button" className="homeBttn onboarding-pill-btn" aria-label="Next step" onClick={handleNextQuestion} style={{marginLeft: 'auto'}}>
                            <svg width="20" height="20" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                                <path d="M3 7h8M7 3l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                            </svg>
                        </button>
                    ) : (
                        null
                    )}
                    {currentQuestion === questionsLearning.length - 3 ? (
                        <button id="relapseSubmit" type="button" className="homeBttn onboarding-pill-btn" aria-label="Next step" onClick={handleSubmitLearning} style={{marginLeft: 'auto'}}>
                            <svg width="20" height="20" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                                <path d="M3 7h8M7 3l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                            </svg>
                        </button>
                    ) : (
                        null
                    )}
                    </div>
                </div>
            );
        
        }
        catch{
            //console.log('some error yo -- need to fix this')
        }
        
    };

    const renderFormRelapse = () => {
        try{
            const currentQ = questionsRelapse[currentQuestion];
            const { question, options } = currentQ;

            return (
                <div className="formContainer">
                    <div className="daily-popup-top-right">
                        <button type="button" className="landing-onboarding-top-close" onClick={handleCloseRelapsePopup} aria-label="Close popup">x</button>
                    </div>
                    <h2 className="onboarding-popup-title">{question}</h2>
                    {currentQ.assets}
                    <div className="popupButtonGroup">
                    {(currentQuestion > 0 && currentQuestion < questionsRelapse.length - 2) && (
                        // <button className="popupNavigationBttn" onClick={handlePreviousQuestion}>Previous</button>
                        <button className="popupNavigationBttn" onClick={handlePreviousQuestion} style={{border:'none', background: 'none'}}>
                            <img className="previousBttn" src={nextBttn} alt="previousBttn" />
                        </button>
                    )}
                    {currentQuestion < questionsRelapse.length - 3 && currentQuestion > 0 ? (
                        // <button className="popupNavigationBttn" onClick={handleNextQuestion}>Next</button>
                        <button type="button" className="homeBttn onboarding-pill-btn" aria-label="Next step" onClick={handleNextQuestion} style={{marginLeft: 'auto'}}>
                            <svg width="20" height="20" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                                <path d="M3 7h8M7 3l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                            </svg>
                        </button>
                    ) : (
                        // <button id="relapseSubmit" className="popupNavigationBttn" onClick={handleSubmitRelapse}>Submit</button>
                        //  <button id="relapseSubmit" className="popupNavigationBttn" onClick={handleSubmitRelapse} style={{border:'none', background: 'none', marginLeft: 'auto'}}>
                        //     <img className="nextBttn" src={nextBttn} alt="nextBttn" />
                        // </button>
                        null
                    )}
                    {currentQuestion === questionsRelapse.length - 3  ? (
                        // <button className="popupNavigationBttn" onClick={handleNextQuestion}>Next</button>
                        <button id="relapseSubmit" type="button" className="homeBttn onboarding-pill-btn" aria-label="Next step" onClick={handleSubmitRelapse} style={{marginLeft: 'auto'}}>
                            <svg width="20" height="20" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                                <path d="M3 7h8M7 3l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                            </svg>
                        </button>
                    ) : (
                        // <button id="relapseSubmit" className="popupNavigationBttn" onClick={handleSubmitRelapse}>Submit</button>
                        null
                    )}
                    </div>
                </div>
            );
        }
        catch{
            //console.log('someerro yo relapse')
        }
    };

    const renderFormGoalSubmit = () => {
        try{
            const currentQ = questionsGoalSubmit[currentQuestion];
            const { question, options } = currentQ;
             return (
                <div className="formContainer">
                    <div className="daily-popup-top-right">
                        {currentQuestion < questionsGoalSubmit.length - 1 ? (
                            <button type="button" className="landing-onboarding-top-close" onClick={handleCloseGoalSubmitPopup} aria-label="Close popup">x</button>
                        ) : (
                            <button type="button" className="landing-onboarding-top-close" onClick={handleCloseGoalSubmitPopup} aria-label="Close popup">x</button>
                        )}
                    </div>
                    <h2 className="onboarding-popup-title">{question}</h2>
                    {currentQ.assets}
                    <div className="popupButtonGroup">
                    {currentQuestion > 0 && currentQuestion < questionsGoalSubmit.length - 2 ? (
                        <button className="popupNavigationBttn" onClick={handlePreviousQuestion} style={{border:'none', background: 'none'}}>
                            <img className="previousBttn" src={nextBttn} alt="previousBttn" />
                        </button>
                    ) : (
                        null
                    )}
                    {/* {currentQuestion < questionsGoalSubmit.length - 2 ? (
                        <button className="popupNavigationBttn" onClick={handleNextQuestion} >Next</button>
                    ) : (
                        <button id="learningSubmit" className="popupNavigationBttn" onClick={handleSubmitLearning} >Submit</button>
                    )} */}
                    {currentQuestion >= 0 && currentQuestion < questionsGoalSubmit.length - 3 ? (
                        <button type="button" className="homeBttn onboarding-pill-btn" aria-label="Next step" onClick={handleNextQuestion} style={{marginLeft: 'auto'}}>
                            <svg width="20" height="20" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                                <path d="M3 7h8M7 3l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                            </svg>
                        </button>
                    ) : (
                        null
                    )}
                    {currentQuestion === questionsGoalSubmit.length - 3 ? (
                        <button id="relapseSubmit" type="button" className="homeBttn onboarding-pill-btn" aria-label="Next step" onClick={handleSubmitLearning} style={{marginLeft: 'auto'}}>
                            <svg width="20" height="20" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                                <path d="M3 7h8M7 3l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                            </svg>
                        </button>
                    ) : (
                        null
                    )}
                    </div>
                </div>
            );
        
        }
        catch{
            //console.log('some error yo -- need to fix this')
        }
        
    };
    
    // End of Popup
    
    const timeElapsed = Date.now();
    const today = new Date(timeElapsed);
    const todayString = today.toDateString();
 
    let wellnessStrek = "N/A"
    // if()
    Math.ceil((today - lastSubmitDate) / 8.64e7)
    
    if (isLoading && dailyContent) {
        return <div className="content">Loading...</div>
    }

    if (!isLoading){
        return (
            <div className="wrapper" style={{ marginTop: '2rem', marginLeft: '1rem', marginRight: '1rem'}}>
                <BrowserNotifications />
                <audio id="myAudio" loop={true}>
                    <source src={relapseAudio} type="audio/mpeg"/>
                    {/* <source src="https://cdn.freesound.org/previews/721/721239_8432823-lq.mp3" type="audio/mpeg" /> */}
                    {/* <source src="https://cdn.freesound.org/previews/721/721239_8432823-lq.ogg" type="audio/ogg"/> */}
                    Your browser does not support the audio element.
                </audio>
                <div className="dailyPopup">
                    {/* <button onClick={handleOpenPopup}>hello</button> */}
                    {/* #4490C3 */}
                    <div className="popupContainer" id="learning-popup"  style={{ display: 'none' }} >{renderFormLearning()}</div>
                    <div className="popupContainer"  id="relapse-popup"  style={{ display: 'none' }}>{renderFormRelapse()}</div>
                    <div className="popupContainer"  id="regulation-popup"  style={{ display: 'none' }}>{renderFormRegulation()}</div>
                    <div className="popupContainer"  id="goal-submit-popup"  style={{ display: 'none' }}>{renderFormGoalSubmit()}</div>
                </div>
                <div className='donut-parent'>
                    <div className="donut"></div>
                </div>
                <div
                    className="container dailyLearningIntro"
                    id="learningContainer"
                    style={{ display: 'none' }}
                >
                    <button type="button" className="dailyLearningIntroBack" onClick={homeHandler}>
                        <svg width="24" height="24" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                            <path
                                d="M11 7H3M7 3L3 7l4 4"
                                stroke="currentColor"
                                strokeWidth="1.0"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </button>
                    <div className="dailyLearningIntroHeader">
                        <h5 id="todayInfo" style={{ textAlign: 'center' }}> Today: {todayString} </h5>
                        <h4 id="todayWelcome">Hello {name}, here is your daily training session </h4>
                    </div>
                    <ul className="dailyLearningTimelineList">
                        <li className='learningTimeline'>
                            <span></span>
                            <div>
                                <div className="title">Learning Content</div>
                                <div className="info">{ dailyLearning.contentname }</div>
                            </div>
                            
                        </li>
                        <li className='learningTimeline'>
                            <div>
                                <span></span>
                                <div className="title">Audio Journal Entry</div>
                                <div className="info">{dailyPrompt.textcontent}</div>
                            </div>
                            <span className="number">
                            </span>
                        </li>
                        <li className='learningTimeline'>
                            <div>
                                <span></span>
                                <div className="title">Daily Goal</div>
                                <div className="info">{dailyGoal.textcontent}</div>
                            </div>
                            <span className="number">
                            </span>
                        </li>
                        <li className='learningTimeline'>
                            <div>
                                <span></span>
                                <div className="title">Progress Entry</div>
                                <div className="info">Track your wellness milestones</div>
                            </div>
                            <span className="number">
                            </span>
                        </li>
                    </ul>
                    <div className="homeBttnContainer dailyLearningIntroActions">
                        <button className="homeBttn" onClick={handleOpenLearningPopup}>Get Started</button>
                    </div>
                </div>
                <div id="homeContainer" className="dailyHomeScreen">
                    <div className="headerContainer dailyHomeHeader" style={{ textAlign:'center' }}>
                        <h2 className="dailyMainTitle">Welcome To Your <br/>Mental Wellness Gym</h2>
                        {/* <h5 className="text-center" style={{ marginTop:'0.5rem' }}> <span className="highlight">latest insight:</span> You're always practicing something. Choose growth, curiosity, and love.</h5> */}

                            {/* <p>This is a <span className="highlight">highlighted</span> word.</p> */}
                        {/* Past weeks workout chart (left = newest / current week; older weeks to the right) */}
                        <div className="workoutBarChart dailyWorkoutBarChart">
                            <div className="dailyChartSummary">
                                <span className="dailyChartSummaryValue">
                                    {(() => {
                                        const rows = weeklyChartDisplayRows;
                                        const e = rows[weekChartSafeIndex];
                                        const real =
                                            e && !e.isGhostPlaceholder
                                                ? e
                                                : rows.find((r) => r && !r.isGhostPlaceholder);
                                        const cur = real ? real.minutes || 0 : 0;
                                        return `${cur} ${cur === 1 ? "min" : "mins"}`;
                                    })()}
                                </span>
                                <span className="dailyChartSummaryLabel">
                                    {(() => {
                                        const rows = weeklyChartDisplayRows;
                                        const e = rows[weekChartSafeIndex];
                                        const real =
                                            e && !e.isGhostPlaceholder
                                                ? e
                                                : rows.find((r) => r && !r.isGhostPlaceholder);
                                        if (!real) return "this week";
                                        return real.isCurrentWeek ? "this week" : `week of ${real.label}`;
                                    })()}
                                </span>
                            </div>
                            <div className="dailyChartPlotRow">
                                <div className="dailyChartYAxis" aria-hidden>
                                    {weeklyChartAxis.yTicks.map((tickVal) => {
                                        const maxM = weeklyChartAxis.maxAxisMinutes;
                                        const isTop = tickVal === maxM;
                                        const isZero = tickVal === 0;
                                        return (
                                            <div
                                                key={`y-${tickVal}`}
                                                className="dailyChartYAxisTick"
                                                style={
                                                    isTop
                                                        ? {
                                                              top: "0",
                                                          }
                                                        : {
                                                              bottom: isZero
                                                                  ? "0"
                                                                  : `calc(${(tickVal / maxM) * 100}% - 0.35rem)`,
                                                          }
                                                }
                                            >
                                                {formatWeeklyAxisTickLabel(tickVal, maxM)}
                                            </div>
                                        );
                                    })}
                                </div>
                                <div className="dailyChartPlotPanel">
                                    {weeklyChartLoading ? (
                                        <div
                                            className="dailyChartPlotInner dailyChartPlotInner--centered"
                                            style={{ height: WEEKLY_CHART_PLOT_PX }}
                                        >
                                            <div className="dailyChartSkeleton" />
                                        </div>
                                    ) : !(Array.isArray(weeklyBarChartData) && weeklyBarChartData.length) ? (
                                        <div
                                            className="dailyChartPlotInner dailyChartPlotInner--centered dailyChartPlotInner--message"
                                            style={{ height: WEEKLY_CHART_PLOT_PX }}
                                        >
                                            No workout data yet
                                        </div>
                                    ) : (
                                        <>
                                            <div
                                                className="dailyChartPlotInner dailyChartBarTrack"
                                                style={{ height: WEEKLY_CHART_PLOT_PX }}
                                            >
                                                {weeklyChartDisplayRows.map((entry, i) => {
                                                    const maxM = weeklyChartAxis.maxAxisMinutes;
                                                    const mins = Math.max(0, Number(entry.minutes) || 0);
                                                    const isDecorGhost = !!entry.isGhostPlaceholder;
                                                    const isGhost = isDecorGhost || mins <= 0;
                                                    const capped = Math.min(mins, maxM);
                                                    const rawH =
                                                        maxM <= 0 || isGhost
                                                            ? 0
                                                            : Math.round((capped / maxM) * WEEKLY_CHART_PLOT_PX);
                                                    const barHeight = isDecorGhost
                                                        ? Math.min(
                                                              WEEKLY_CHART_PLOT_PX - 4,
                                                              Math.max(
                                                                  10,
                                                                  Number(entry.ghostHeightPx) || WEEKLY_CHART_GHOST_BAR_PX
                                                              )
                                                          )
                                                        : isGhost
                                                          ? WEEKLY_CHART_GHOST_BAR_PX
                                                          : Math.max(rawH, maxM < 180 ? 11 : 2);
                                                    const isSelected = weekChartSafeIndex === i;
                                                    if (isDecorGhost) {
                                                        return (
                                                            <div
                                                                key={`bar-ph-${i}`}
                                                                className="dailyChartBarColumn--decor"
                                                                aria-hidden="true"
                                                            >
                                                                <div
                                                                    className="dailyChartBarDecor"
                                                                    style={{ height: barHeight }}
                                                                />
                                                            </div>
                                                        );
                                                    }
                                                    const solidEmphasis = mins > 0 && (entry.isCurrentWeek || isSelected);
                                                    const ghostEmphasis = isGhost && (isSelected || entry.isCurrentWeek);
                                                    const fillClass = [
                                                        "dailyChartBarFill",
                                                        isGhost ? "dailyChartBarFill--ghost" : "dailyChartBarFill--solid",
                                                        solidEmphasis ? "dailyChartBarFill--emphasis" : "",
                                                        ghostEmphasis ? "dailyChartBarFill--ghostEmphasis" : "",
                                                        !isGhost && mins > 0 && !entry.complete ? "dailyChartBarFill--dim" : "",
                                                    ]
                                                        .filter(Boolean)
                                                        .join(" ");
                                                    return (
                                                        <div
                                                            key={`bar-${entry.label || "wk"}-${i}`}
                                                            className="dailyChartBarColumn dailyChartBarColumn--interactive"
                                                            role="button"
                                                            tabIndex={0}
                                                            aria-pressed={isSelected}
                                                            aria-label={
                                                                isGhost
                                                                    ? `${entry.label}: no minutes logged. Select to show in summary.`
                                                                    : `${entry.label}: ${entry.minutes || 0} minutes. Select to show in summary.`
                                                            }
                                                            onClick={() => setWeekChartSelectedIndex(i)}
                                                            onKeyDown={(ev) => {
                                                                if (ev.key === "Enter" || ev.key === " ") {
                                                                    ev.preventDefault();
                                                                    setWeekChartSelectedIndex(i);
                                                                }
                                                            }}
                                                        >
                                                            <div
                                                                className={fillClass}
                                                                title={isGhost ? `No time logged — ${entry.label}` : weekMinutesTooltip(entry)}
                                                                style={{ height: barHeight }}
                                                            />
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                            <div className="dailyChartBarLabels">
                                                {weeklyChartDisplayRows.map((entry, i) => (
                                                    <div
                                                        key={`lbl-${i}`}
                                                        className={`dailyChartBarLabel${entry.isGhostPlaceholder ? " dailyChartBarLabel--muted" : ""}`}
                                                    >
                                                        {entry.isGhostPlaceholder ? "\u00a0" : entry.label}
                                                    </div>
                                                ))}
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                            {!weeklyChartLoading &&
                            Array.isArray(weeklyBarChartData) &&
                            weeklyBarChartData.length > 0 &&
                            weeklyChartMotivationLine ? (
                                <div className="dailyChartMotivation">
                                    {weeklyChartMotivationLine}
                                </div>
                            ) : null}
                        </div>
                        <div onClick={() => setIsExploding(!isExploding)} 
                            style={{
                                position: "absolute",
                                top: "0", // Top of the screen
                                left: "50%",
                                transform: "translateX(-50%)", // Center horizontally
                                width: "100px", // Small width to control the source of particles
                                height: "10px", // Small height to keep them near the top
                        }}>
                            {isExploding && <ConfettiExplosion {...largeProps}/>}
                            {/* <span>small</span> */}
                        </div>
                        <div className="dailyStreakPills" role="list" aria-label="Streak summary">
                            <div className="dailyStreakPill" role="listitem">
                                <span className="dailyStreakPillValue">{Math.ceil((today - lastSubmitDate) / 8.64e7)}</span>
                                <span className="dailyStreakPillLabel">Wellness streak</span>
                            </div>
                            <div className="dailyStreakPill" role="listitem">
                                <span className="dailyStreakPillValue">{workoutStreak}</span>
                                <span className="dailyStreakPillLabel">Workout streak</span>
                            </div>
                            <div className="dailyStreakPill" role="listitem">
                                <span className="dailyStreakPillValue">{goalCount}</span>
                                <span className="dailyStreakPillLabel">Goals completed</span>
                            </div>
                        </div>
                        <h4 className="dailyBigGoal"> <span className="dailyBigGoalPrefix">{name}'s big goal:</span> <TextExpander  wordLimit={12} text={currentGoal} /></h4>
                        <div
                            className="dailyHeroCard"
                            role="button"
                            tabIndex={0}
                            style={{
                                backgroundImage: `linear-gradient(160deg, rgba(8, 16, 28, 0.68), rgba(8, 16, 28, 0.35)), url(${dailyHeroBackground})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                            }}
                            onClick={workoutCompleted ? handleGoalCompleted : learningHandler}
                            onKeyDown={(ev) => {
                                if (ev.key === 'Enter' || ev.key === ' ') {
                                    ev.preventDefault();
                                    if (workoutCompleted) {
                                        handleGoalCompleted();
                                    } else {
                                        learningHandler();
                                    }
                                }
                            }}
                        >
                            <div className="dailyHeroCardContent">
                                <p className="dailyHeroCardEyebrow">{workoutCompleted ? 'Daily Goal' : 'Daily Workout'}</p>
                                <h3 className="dailyHeroCardTitle">
                                    <TextExpander wordLimit={10} text={workoutCompleted ? dailyGoalTitle : dailyLearning.contentname} />
                                </h3>
                                <p className="dailyHeroCardMeta">
                                    {workoutCompleted ? 'Workout complete. Lock in your daily goal.' : 'approx. 10 mins'}
                                </p>
                            </div>
                            <span className="dailyHeroCardArrow" aria-hidden="true">→</span>
                        </div>
                    </div>
                    
                    <button
                        className="dailyActionCard"
                        style={buildCardBackgroundStyle(DAILY_SETBACK_BG_KEY, 0.62)}
                        onClick={handleOpenRelapsePopup}
                    >
                        <div className="dailyActionCardContent">
                            <h4 className="dailyActionCardTitle">Setback Support</h4>
                            <p className="dailyActionCardMeta">Get immediate support when momentum dips. Turn setbacks into growth.</p>
                        </div>
                    </button>

                    <button
                        className="dailyActionCard"
                        style={buildCardBackgroundStyle(DAILY_GYM_BG_KEY, 0.56)}
                        onClick={handleGymNavigate}
                    >
                        <div className="dailyActionCardContent">
                            <h4 className="dailyActionCardTitle">Wellness Gym Exercises</h4>
                            <p className="dailyActionCardMeta">Practice guided reps and strengthen resilience. Build emotional fitness.</p>
                        </div>
                    </button>

                
                </div>
                {/* <div className="dailySection"> 
                    <div className="learningFeedback">
                        <p> Content Takeaways </p>
                        <textarea className="textinput" name="paragraph_text" cols="50" value={contentFeedback} onChange={event => setContentFeedback(event.target.value)}></textarea>
                    </div> 
                </div>
                <div className="dailySection"> 
                    <div className="learningFeedback">
                        <p> <b>Audio Journal Entry</b> </p>
                        <div className="audioJournal">
                            <p> Journal Prompt: { dailyPrompt.textcontent } </p>
                            <div> <AudioRecorder saveAudio= {handleAudioState} /> </div>                   
                        </div>
                    </div> 
                </div>
                <div className="dailySection">
                    <div className="learningFeedback">
                        <p> <b>Daily Goal</b> </p>
                        <div className="container">
                            <input type="text" value={dailyGoalTitle} onChange={event => setDailyGoalTitle(event.target.value)} /> <br />
                            <input type="text" value={dailyGoalNotification} onChange={event => setDailyGoalNotifications(event.target.value)} /> <br />            
                        </div>
                    </div>
                </div>
                <div className="dailySection"> 
                    <div>
                        <p> <b>Prior Day Progress Entry</b> </p>
                        Morning Use: <input type="text" value={morningUse} placeholder="1-10 (1 as in poor 10 as in great)" onChange={event => setMorningUse(event.target.value)} /> <br />
                        Afternoon Use: <input type="text" value={afternoonUse} placeholder="1-10 (1 as in poor 10 as in great)" onChange={event => setAfternoonUse(event.target.value)} /> <br />
                        Night Use: <input type="text" value={nightUse} placeholder="1-10 (1 as in poor 10 as in great)" onChange={event => setNightUse(event.target.value)} /> <br />
                        Current Confidence: <input type="text" value={currentConfidence} placeholder="Confidence in meeting goal, 1-10" onChange={event => setCurrentConfidence(event.target.value)} /> <br />
                        <p>Prior Day Takeaways:</p> <textarea className="textinput" name="paragraph_text" cols="50" value={yesterdayTakeaways} onChange={event => setYesterdayTakeaways(event.target.value)}></textarea>
                    </div>
                </div> */}
                {/* <input className="submit-bttn" type="button" value="Submit" onClick={submitHandler} />
                {errorMessage && <p className="message"> { errorMessage } </p>}
                <br></br> */}
            </div>
        )
    }
}


export default DailyContent;